<template>
    <div style="display:flex;flex-direction:column;position:relative">
        <div style="display:flex;align-items:center">
            <div class="select-filters" ref="filtersContainer" @scroll="checkScrollPosition">
                <div :class="{activeFilter:selectedFilter == 'Basic'}" @click="changeFilter('Basic')" class="notification-filters">{{$t('Basic')}}</div>
                <div :class="{activeFilter:selectedFilter == 'Search'}" @click="changeFilter('Search')" class="notification-filters">{{$t('Search')}}</div>
                <div :class="{activeFilter:selectedFilter == 'Archive'}" @click="changeFilter('Archive')" class="notification-filters">{{$t('Archive')}}</div>
                <div :class="{activeFilter:selectedFilter == 'Deletion'}" @click="changeFilter('Deletion')" class="notification-filters">{{$t('Deletion')}}</div>
                <div :class="{activeFilter:selectedFilter == 'Language'}" @click="changeFilter('Language')" class="notification-filters">{{$t('Language')}}</div>
                <div :class="{activeFilter:selectedFilter == 'DateTime'}" @click="changeFilter('DateTime')" class="notification-filters">{{$t('Date and Time')}}</div>
                <div :class="{activeFilter:selectedFilter == 'Reports'}" @click="changeFilter('Reports')" class="notification-filters">{{$t('Reports')}}</div>
                <div :class="{activeFilter:selectedFilter == 'ReferenceId'}" @click="changeFilter('ReferenceId')" class="notification-filters">{{$t('Reference ID')}}</div>
                <div v-if="hardSubclipConfig && Object.keys(hardSubclipConfig).length > 0" :class="{activeFilter:selectedFilter == 'Subclips'}" @click="changeFilter('Subclips')" class="notification-filters">{{$t('Subclips')}}</div>
                <div :class="{activeFilter:selectedFilter == 'LockedFiles'}" @click="changeFilter('LockedFiles')" class="notification-filters">{{$t('Locked Files')}}</div>
                <div :class="{activeFilter:selectedFilter == 'ClientBranding'}" @click="changeFilter('ClientBranding')" class="notification-filters">{{$t('Client Branding')}}</div>
                <div :class="{activeFilter:selectedFilter == 'Preview'}" @click="changeFilter('Preview')" class="notification-filters">{{$t('Preview')}}</div>
                <div v-if="LDAPConfig && Object.keys(LDAPConfig).length > 0" :class="{activeFilter:selectedFilter == 'LDAP'}" @click="changeFilter('LDAP')" class="notification-filters">{{$t('LDAP')}}</div>
                <div :class="{activeFilter:selectedFilter == 'Mobile'}" @click="changeFilter('Mobile')" class="notification-filters">{{$t('Fusion Mobile')}}</div>
                <div :class="{activeFilter:selectedFilter == 'AI'}" @click="changeFilter('AI')" class="notification-filters">{{$t('AI')}}</div>
            </div>
            <div class="scroll-icons" v-if="showArrows">
                <svg @click="scrollLeft" :class="{disabledArrow: !canScrollLeft}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left mr-2" viewBox="0 0 16 16" style="border: 1px solid #eee; border-radius: 50%; padding: 4px; box-sizing: content-box;">
                    <title></title>
                    <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                </svg>
                <svg @click="scrollRight" :class="{disabledArrow: !canScrollRight}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" style="border: 1px solid #eee; border-radius: 50%; padding: 4px; box-sizing: content-box;">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                </svg>
            </div>
        </div>
        <div style="overflow-y: auto;height: calc(100% - 60px);overflow-x: hidden;">
            <table class="table comm-table-styles" id="global_settings_table" style="background: transparent;display: block;padding-bottom: 35px;">
            <!-- <thead style="color: #eee">
                <tr>
                <th scope="col" style="width: 20%"></th>
                <th scope="col" style="width: 80%"></th>
                </tr>
            </thead> -->
            <tbody>
                <tr ref="globalSettingsBasic">
                    <td colspan="2">
                        <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                            <button class="btn text-white p-0 pl-2" @click="viewBasicConfig = !viewBasicConfig">
                                <svg v-if="viewBasicConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!viewBasicConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            </button>
                            <h6 class="m-0 text-left">{{$t('Basic')}}</h6>
                        </div>
                    </td>
                </tr>
                <template v-if="viewBasicConfig">
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Main Elastic-search IP')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('MAIN_ELASTIC_DB_IP')">{{
                                globalSettingsInfo.MAIN_ELASTIC_DB_IP
                            }}</span>
                            <span v-else-if="!globalSettingsInfo.MAIN_ELASTIC_DB_IP" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('MAIN_ELASTIC_DB_IP')"
                                v-show="!isEditting('MAIN_ELASTIC_DB_IP')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('MAIN_ELASTIC_DB_IP')"
                                type="text"
                                min="0"
                                ref="MAIN_ELASTIC_DB_IP"
                                @keypress.enter="updateSelectedAsDefaultPool('MAIN_ELASTIC_DB_IP')"
                                v-model="elasticSearchIP"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-show="isEditting('MAIN_ELASTIC_DB_IP')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('MAIN_ELASTIC_DB_IP')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.MAIN_ELASTIC_DB_IP_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'>
                    <td class="key-div">{{$t('Notifier Endpoint IP')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                            <div class="w-100">
                                <div class="d-inline-flex">
                                    <span v-if="!isEditting('NOTIFIER_ENDPOINT_IP') && globalSettingsInfo.NOTIFIER_ENDPOINT_IP">{{ globalSettingsInfo.NOTIFIER_ENDPOINT_IP }}</span>
                                    <span v-else-if="!isEditting('NOTIFIER_ENDPOINT_IP')" class="empty-field-text-styles">NONE</span>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('NOTIFIER_ENDPOINT_IP')"
                                        v-show="!isEditting('NOTIFIER_ENDPOINT_IP')"
                                        class="editIcon"
                                    ></edit-icon>
                                </div>
                                <input
                                    v-if="isEditting('NOTIFIER_ENDPOINT_IP')"
                                    type="text"
                                    ref="NOTIFIER_ENDPOINT_IP"
                                    @keypress.enter="updateSelectedAsDefaultPool('NOTIFIER_ENDPOINT_IP')"
                                    v-model="notifierEndpointIp"
                                    class="rounded text-light comm-input-field-style align-input-field"
                                />
                            </div>
                            <div v-show="isEditting('NOTIFIER_ENDPOINT_IP')">
                                <div class="d-flex">
                                    <save-icon @click.native="updateSelectedAsDefaultPool('NOTIFIER_ENDPOINT_IP')"></save-icon>
                                    <cancel-icon @click.native="cancelEdit()"></cancel-icon>
                                </div>
                            </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">{{ globalSettingsInfo.NOTIFIER_ENDPOINT_IP_desc }}</div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Main Notifier IP')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('MAIN_NOTIFIER_IP')">{{
                                globalSettingsInfo.MAIN_NOTIFIER_IP
                            }}</span>
                            <span v-else-if="!globalSettingsInfo.MAIN_NOTIFIER_IP" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('MAIN_NOTIFIER_IP')"
                                v-show="!isEditting('MAIN_NOTIFIER_IP')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('MAIN_NOTIFIER_IP')"
                                type="text"
                                min="0"
                                ref="MAIN_NOTIFIER_IP"
                                @keypress.enter="updateSelectedAsDefaultPool('MAIN_NOTIFIER_IP')"
                                v-model="notifierIP"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-show="isEditting('MAIN_NOTIFIER_IP')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('MAIN_NOTIFIER_IP')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.MAIN_NOTIFIER_IP_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Secondary Notifier IP')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('SECONDARY_NOTIFIER_IP')">{{
                                globalSettingsInfo.SECONDARY_NOTIFIER_IP
                            }}</span>
                            <span v-else-if="!globalSettingsInfo.SECONDARY_NOTIFIER_IP" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('SECONDARY_NOTIFIER_IP')"
                                v-show="!isEditting('SECONDARY_NOTIFIER_IP')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('SECONDARY_NOTIFIER_IP')"
                                type="text"
                                min="0"
                                ref="SECONDARY_NOTIFIER_IP"
                                @keypress.enter="updateSelectedAsDefaultPool('SECONDARY_NOTIFIER_IP')"
                                v-model="secondaryNotifierIP"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-show="isEditting('SECONDARY_NOTIFIER_IP')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('SECONDARY_NOTIFIER_IP')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.SECONDARY_NOTIFIER_IP_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Preview redirect URL')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('redirect_url')">{{
                                getReadableRedirectURL
                            }}</span>
                            <span v-else-if="!globalSettingsInfo.redirect_url" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('redirect_url')"
                                v-show="!isEditting('redirect_url')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('redirect_url')"
                                type="text"
                                min="0"
                                ref="redirect_url"
                                @keypress.enter="updateSelectedAsDefaultPool('redirect_url')"
                                v-model="redirectURL"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-show="isEditting('redirect_url')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('redirect_url')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.redirect_url_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Set catalog field as read only')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateCatalogReadOnlyToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch1"
                                :checked='globalSettingsInfo.CATALOG_READ_ONLY'/>
                            <label class="custom-control-label" for="customSwitch1"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.CATALOG_READ_ONLY_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Disable secure password enforcement')}} </td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updatePasswordEnforcemenToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch3"
                                :checked='globalSettingsInfo.DISABLE_SECURED_PASSWORD_ENFORCEMENT'/>
                            <label class="custom-control-label" for="customSwitch3"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.DISABLE_SECURED_PASSWORD_ENFORCEMENT_desc}}
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            NOTE: Strongly recommended to keep the field disable
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Configure description from screen')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateConfDescriptionFScreenToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch5"
                                :checked='globalSettingsInfo.configure_description_from_screen'/>
                            <label class="custom-control-label" for="customSwitch5"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.configure_description_from_screen_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Configure Catalogs from screen')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateConfCatalogFScreenToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch6"
                                :checked='globalSettingsInfo.configure_catalogs_from_screen'/>
                            <label class="custom-control-label" for="customSwitch6"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.configure_catalogs_from_screen_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Enable multi catalog')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateMultiCatalogToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch10"
                                :checked='globalSettingsInfo.enable_multi_catalog_browse'/>
                            <label class="custom-control-label" for="customSwitch10"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.enable_multi_catalog_browse_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Configure Tags from screen')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateConfTagsFScreenToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch7"
                                :checked='globalSettingsInfo.configure_tags_from_screen'/>
                            <label class="custom-control-label" for="customSwitch7"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.configure_tags_from_screen_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Configure upload path from screen')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateConfUploadLocationFScreenToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch8"
                                :checked='globalSettingsInfo.configure_upload_location_from_screen'/>
                            <label class="custom-control-label" for="customSwitch8"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.configure_upload_location_from_screen_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'>
                    <td class="key-div">{{$t('Enable resumable uploads')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateResumableUploadToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="resumableUploadCustomSwitch"
                                :checked='globalSettingsInfo.enable_resumable_uploads'/>
                            <label class="custom-control-label" for="resumableUploadCustomSwitch"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.enable_resumable_uploads_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'>
                    <td class="key-div">{{$t('Enable folder upload')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateFolderUploadToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="folderUploadCustomSwitch"
                                :checked='globalSettingsInfo.enable_folder_upload'/>
                            <label class="custom-control-label" for="folderUploadCustomSwitch"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.enable_folder_upload_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'>
                    <td class="key-div">{{$t('Media edit advanced controls')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateMediaEditAdvancedControl($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="mediaEditAdvancedControl"
                                :checked='globalSettingsInfo.media_edit_advanced_controls'/>
                            <label class="custom-control-label" for="mediaEditAdvancedControl"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.media_edit_advanced_controls_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'>
                    <td class="key-div">{{$t('Show subclips')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateSubclipShowControl($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="showSubclipControl"
                                :checked='globalSettingsInfo.search_subclips'/>
                            <label class="custom-control-label" for="showSubclipControl"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.search_subclips_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Asset count display')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateAssetsCountControl($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="showAssetsCountControl"
                                :checked='globalSettingsInfo.enable_assets_tree_count'/>
                            <label class="custom-control-label" for="showAssetsCountControl"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.enable_assets_tree_count_desc}}
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            NOTE: Strongly recommended to keep the field disable as this flag affects system performance.
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'>
                    <td class="key-div">{{$t('Enable Department')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateEnableProjectToggleValue($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch15"
                                :checked='globalSettingsInfo.enable_department'/>
                            <label class="custom-control-label" for="customSwitch15"></label>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.enable_department_desc}}
                        </div>
                    </td>
                </tr>
                <tr v-if="globalSettingsInfo.enable_department" class='d-flex'>
                    <td class="key-div">{{$t('Alias of Department')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                            <div class="w-100">
                                <div v-if="!isEditting('department_alias_name')" class="d-inline-flex">
                                <span v-if="globalSettingsInfo.department_alias">{{
                                    globalSettingsInfo.department_alias.alias_name
                                }}</span>
                                <span v-else-if="!globalSettingsInfo.department_alias || !globalSettingsInfo.department_alias.alias_name" class="empty-field-text-styles">NONE</span>
                                <edit-icon
                                    @click.native="editGlobalSettingsField('department_alias_name')"
                                    v-show="!isEditting('department_alias_name')"
                                    class="editIcon"
                                ></edit-icon>
                                </div>
                                <input
                                    v-if="isEditting('department_alias_name')"
                                    type="text"
                                    min="0"
                                    ref="department_alias_name"
                                    :placeholder="$t('Enter the alias of department')"
                                    @keypress.enter="updateAliasOfDepartment('department_alias_name')"
                                    v-model="departmentAliasName"
                                    class="rounded text-light comm-input-field-style align-input-field"
                                />
                            </div>
                        <div v-show="isEditting('department_alias_name')" >
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateAliasOfDepartment('department_alias_name')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" >
                            {{globalSettingsInfo.department_alias_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Web app force logout duration')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('web_app_force_logout_duration')">{{
                                globalSettingsInfo.web_app_force_logout_duration
                            }} minutes</span>
                            <span v-else-if="!isEditting('web_app_force_logout_duration') && !globalSettingsInfo.web_app_force_logout_duration" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('web_app_force_logout_duration')"
                                v-show="!isEditting('web_app_force_logout_duration')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('web_app_force_logout_duration')"
                                type="number"
                                min="0"
                                ref="web_app_force_logout_duration"
                                @keypress.enter="updateSelectedAsDefaultPool('web_app_force_logout_duration')"
                                v-model="webForceLogoutConfig"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-show="isEditting('web_app_force_logout_duration')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('web_app_force_logout_duration')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.web_app_force_logout_duration_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Enable Remember Password')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateRememberPassword($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="enableRememberPassword"
                                :checked='globalSettingsInfo.enable_remember_password'/>
                            <label class="custom-control-label" for="enableRememberPassword"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.enable_remember_password_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Fetch file as')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex" v-if="!isEditting('fetch_file_with_name')">
                                <span v-if="!isEditting('fetch_file_with_name')">{{
                                    globalSettingsInfo.fetch_file_with_name ? globalSettingsInfo.fetch_file_with_name : ""
                                }}</span>
                                <span v-else-if="!globalSettingsInfo.fetch_file_with_name" class="empty-field-text-styles">{{selectedFetchFileWithName}}</span>
                                <edit-icon
                                    @click.native="editGlobalSettingsField('fetch_file_with_name')"
                                    v-show="!isEditting('fetch_file_with_name')"
                                    class="editIcon"
                                ></edit-icon>
                            </div>
                            <Multiselect
                                v-if="isEditting('fetch_file_with_name')"
                                v-model="selectedFetchFileWithName"
                                :options="fetchFileWithNameOptions"
                                :placeholder="$t('Select File Name')"
                                :hideSelected="false"
                                :close-on-select="true"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                :showNoOptions="false"
                                class="align-input-field"
                                @select="handleFetchFileWithNameSelection($event)"
                                >
                                <!-- @open="dropDownOpened" -->
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                        <div v-show="isEditting('fetch_file_with_name')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('fetch_file_with_name')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.fetch_file_with_name_desc}}
                        </div>
                    </td>   
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Fetch high resolution')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateExportRes($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="enableHighresExport"
                                :checked='globalSettingsInfo.export_highres_proxy'/>
                            <label class="custom-control-label" for="enableHighresExport"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.export_highres_proxy_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'>
                    <td class="key-div">{{$t('Enable Notification Filtering')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateNofificationFilter($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="enableNotificationFiltering"
                                :checked='globalSettingsInfo.enable_notification_filtering'/>
                            <label class="custom-control-label" for="enableNotificationFiltering"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.enable_notification_filtering_desc}}
                        </div>
                    </td>
                </tr>
                </template>

                <template>
                    
                    <tr ref="globalSettingsSearch">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="viewSearchConfig = !viewSearchConfig">
                                    <svg v-if="viewSearchConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                    <svg v-if="!viewSearchConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Search')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template v-if="viewSearchConfig">
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Auto complete for assets search')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateSearchAutoCompleteToggleValue($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="customSwitch4"
                                        :checked='globalSettingsInfo.enable_auto_complete_for_assets_search'/>
                                    <label class="custom-control-label" for="customSwitch4"></label>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.enable_auto_complete_for_assets_search_desc}}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="globalSettingsInfo.asset_global_keyword_search_filters" class='d-flex'>
                            <td class="key-div">{{$t('Asset global keyword search filters')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                <div class="w-75">
                                    <div class="d-inline-flex" v-if="!isEditting('asset_global_keyword_search_filters')" style="flex-wrap:wrap">
                                        <div v-if="!searchInFilterValues || searchInFilterValues.length == 0" class="empty-field-text-styles">NONE</div>
                                        <div v-else v-for="fItem in searchInFilterValues" :key="fItem" class="search-in-filter-styles">
                                            {{ fItem }}
                                        </div>
                                        <edit-icon
                                            @click.native="editGlobalSettingsField('asset_global_keyword_search_filters')"
                                            v-show="!isEditting('asset_global_keyword_search_filters')"
                                            class="editIcon"
                                        ></edit-icon>
                                    </div>
                                    <Multiselect
                                        v-if="isEditting('asset_global_keyword_search_filters')"
                                        v-model="searchInFilterValues"
                                        :options="searchInKeywordsArr"
                                        :placeholder="$t('Select filters')"
                                        :hideSelected="false"
                                        :close-on-select="true"
                                        deselectLabel=""
                                        selectLabel=""
                                        selectedLabel=""
                                        :showNoOptions="false"
                                        :multiple="true"
                                        class="align-input-field-assets-search"
                                        ref="dateTimeFormatDropdown"
                                        >
                                        <!-- @open="dropDownOpened" -->
                                        <span slot="noResult">No results.</span>
                                    </Multiselect>
                                </div>
                                <div v-if="isEditting('asset_global_keyword_search_filters')" style="display: flex;align-items: center;">
                                    <div class="d-flex">
                                    <save-icon
                                        @click.native="updateSelectedAsDefaultPool('asset_global_keyword_search_filters')"
                                    ></save-icon>
                                    <cancel-icon
                                        @click.native="cancelEdit()"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.asset_global_keyword_search_filters_desc}}
                                </div>
                            </td>   
                        </tr>
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Enable wildcard search')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateWildcardSearchToggleValue($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="enable_wildcard_search"
                                        :checked='globalSettingsInfo.enable_wildcard_search'/>
                                    <label class="custom-control-label" for="enable_wildcard_search"></label>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.enable_wildcard_search_desc}}
                                </div>
                            </td>
                        </tr>
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Enable Semantic Search')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateNLPConfiguration($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="enableNLPSearch"
                                        :checked='globalSettingsInfo.enable_nlp_search'/>
                                    <label class="custom-control-label" for="enableNLPSearch"></label>
                                </div>
                                <div class="config-desc">
                                    {{globalSettingsInfo.enable_nlp_search_desc}}
                                </div>
                            </td>
                        </tr>
        
                        <tr class='d-flex' v-if="globalSettingsInfo.enable_nlp_search">
                            <td class="key-div">{{$t('Model for Semantic search')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                    <div class="w-75">
                                        <div class="d-inline-flex" v-if="!isEditting('selected_model_for_nlp')" style="flex-wrap:wrap">
                                            <div v-if="!globalSettingsInfo.selected_model_for_nlp || globalSettingsInfo.selected_model_for_nlp.length == 0" class="empty-field-text-styles">{{$t('NONE')}}</div>
                                            <div v-else class="search-in-filter-styles">
                                                {{ globalSettingsInfo.selected_model_for_nlp }}
                                            </div>
                                            <edit-icon
                                                @click.native="editGlobalSettingsField('selected_model_for_nlp')"
                                                v-show="!isEditting('selected_model_for_nlp')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <Multiselect
                                            v-if="isEditting('selected_model_for_nlp')"
                                            v-model="selectedNLPModel"
                                            :options="['bge_m3']"
                                            :placeholder="$t('Select model')"
                                            :hideSelected="false"
                                            :close-on-select="true"
                                            deselectLabel=""
                                            selectLabel=""
                                            selectedLabel=""
                                            :showNoOptions="false"
                                            class="align-input-field-assets-search"
                                            ref="lockActionsDropdown"
                                            @select="selectedNLPModel = $event"
                                            >
                                            <span slot="noResult">{{$t('No results.')}}</span>
                                        </Multiselect>
                                    </div>
                                    <div v-if="isEditting('selected_model_for_nlp')" style="display: flex;align-items: center;">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateSelectedAsDefaultPool('selected_model_for_nlp')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="cancelEdit('selected_model_for_nlp')"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{globalSettingsInfo.selected_model_for_nlp_desc}}
                                    </div>
                            </td>
                        </tr>
                        <tr class='d-flex' v-if="globalSettingsInfo.enable_nlp_search">
                            <td class="key-div">{{$t('Semantic Search Elastic IP')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                <div class="w-100">
                                    <div class="d-inline-flex">
                                    <span v-if="!isEditting('NLP_ELASTIC_DB_IP')">{{
                                        globalSettingsInfo.NLP_ELASTIC_DB_IP
                                    }}</span>
                                    <span v-else-if="!globalSettingsInfo.NLP_ELASTIC_DB_IP" class="empty-field-text-styles">NONE</span>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('NLP_ELASTIC_DB_IP')"
                                        v-show="!isEditting('NLP_ELASTIC_DB_IP')"
                                        class="editIcon"
                                    ></edit-icon>
                                    </div>
                                    <input
                                        v-if="isEditting('NLP_ELASTIC_DB_IP')"
                                        type="text"
                                        min="0"
                                        ref="NLP_ELASTIC_DB_IP"
                                        @keypress.enter="updateSelectedAsDefaultPool('NLP_ELASTIC_DB_IP')"
                                        v-model="nlpElasticSearchIP"
                                        class="rounded text-light comm-input-field-style align-input-field"
                                    />
                                </div>
                                <div v-show="isEditting('NLP_ELASTIC_DB_IP')">
                                    <div class="d-flex">
                                    <save-icon
                                        @click.native="updateSelectedAsDefaultPool('NLP_ELASTIC_DB_IP')"
                                    ></save-icon>
                                    <cancel-icon
                                        @click.native="cancelEdit()"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.NLP_ELASTIC_DB_IP_desc}}
                                </div>
                            </td>
                        </tr>
                        <tr class='d-flex' v-if="globalSettingsInfo.enable_nlp_search">
                            <td class="key-div">{{$t('Semantic search service IP')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                <div class="w-100">
                                    <div class="d-inline-flex">
                                    <span v-if="!isEditting('NLP_SERVICE_IP') && globalSettingsInfo.NLP_SERVICE_IP">{{
                                        globalSettingsInfo.NLP_SERVICE_IP
                                    }}</span>
                                    <span v-else-if="!isEditting('NLP_SERVICE_IP') && !globalSettingsInfo.NLP_SERVICE_IP" class="empty-field-text-styles">NONE</span>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('NLP_SERVICE_IP')"
                                        v-if="!isEditting('NLP_SERVICE_IP')"
                                        class="editIcon"
                                    ></edit-icon>
                                    </div>
                                    <input
                                        v-if="isEditting('NLP_SERVICE_IP')"
                                        type="text"
                                        min="0"
                                        ref="NLP_SERVICE_IP"
                                        @keypress.enter="updateSelectedAsDefaultPool('NLP_SERVICE_IP')"
                                        v-model="nlpServiceIP"
                                        class="rounded text-light comm-input-field-style align-input-field"
                                    />
                                </div>
                                <div v-if="isEditting('NLP_SERVICE_IP')">
                                    <div class="d-flex">
                                    <save-icon
                                        @click.native="updateSelectedAsDefaultPool('NLP_SERVICE_IP')"
                                    ></save-icon>
                                    <cancel-icon
                                        @click.native="cancelEdit()"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.NLP_SERVICE_IP_desc}}
                                </div>
                            </td>
                        </tr>
                        <template v-if="searchSConfigurations">
                            <!-- <tr class="d-flex">
                                <td class="key-div"> {{$t('Separator Operators')}}</td>
                                <td class="value-div w-30 float-left m-0" style="margin-right: 0px !important;padding-right: 0px !important;padding-top: 4px !important;">
                                    <div style="display:flex">
                                        <div v-for="(operator, separator) in searchSConfigurations.separator_operators" :key="separator" class="separator-operator-row">
                                            <span class="separator-key">{{ getSeparatorLabel(separator) }}</span>

                                            <div class="custom-select-wrapper">
                                                <select v-model="searchSConfigurations.separator_operators[separator]"  class="separator-select" @change="updateSeparatorOperators">
                                                    <option value="AND">AND</option>
                                                    <option value="OR">OR</option>
                                                </select>

                                                <span class="dropdown-arrow">⌄</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="!searchSConfigurations.separator_operators || Object.keys(searchSConfigurations.separator_operators).length === 0" class="empty-field-text-styles">
                                        NONE
                                    </div>

                                    <div class="config-desc">
                                        {{searchSConfigurations.separator_operators_desc}}
                                    </div>
                                </td>
                            </tr> -->
                            <tr v-if="searchSConfigurations.stop_words" class="d-flex">
                                <td class="key-div"> {{$t('Stop words')}} </td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                        <div class="d-inline-flex" style="flex-wrap: wrap">
                                            <!-- No stop words -->
                                            <div v-if="!searchSConfigurations.stop_words ||   searchSConfigurations.stop_words.length === 0"  class="empty-field-text-styles" >
                                                NONE
                                            </div>

                                            <!-- Display first 20 -->
                                            <div v-else v-for="word in searchSConfigurations.stop_words.slice(0, 20)" :key="word" class="search-in-filter-styles" >
                                                {{ word }}
                                            </div>

                                            <!-- Show remaining count -->
                                            <div v-if="searchSConfigurations.stop_words &&  searchSConfigurations.stop_words.length > 20" class="search-in-filter-styles more-count" >
                                                + {{ searchSConfigurations.stop_words.length - 20 }} more
                                            </div>

                                            <edit-icon
                                                @click.native="editGlobalSettingsField('stop_words')"
                                                v-show="!isEditting('stop_words')"
                                                class="editIcon"
                                            ></edit-icon>

                                        </div>
                                    </div>

                                    <div class="config-desc" style="width: 100%;">
                                        {{globalSettingsInfo.stop_words_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Stop words last edited datetime')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div>
                                        <span v-if="searchSConfigurations.stop_words_last_edited_datetime">{{getDateAndTimeInConfiguredFormat(searchSConfigurations.stop_words_last_edited_datetime)}}</span>
                                        <span v-else class="empty-field-text-styles">NONE</span>
                                    </div>
                                    <div class="config-desc">
                                        {{searchSConfigurations.stop_words_last_edited_datetime_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('ElasticSearch index created datetime')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div>
                                        <span v-if="searchSConfigurations.es_index_created_datetime">{{getDateAndTimeInConfiguredFormat(searchSConfigurations.es_index_created_datetime)}}</span>
                                        <span v-else class="empty-field-text-styles">NONE</span>
                                    </div>
                                    <div class="config-desc">
                                        {{searchSConfigurations.es_index_created_datetime_desc}}
                                    </div>
                                </td>
                            </tr>
                        </template>

                    </template>
                </template>

                <template>
                    <tr ref="globalSettingsArchive">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="isArchiveConfigOpen = !isArchiveConfigOpen">
                                <svg v-if="isArchiveConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!isArchiveConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Archive')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template v-if="isArchiveConfigOpen">
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Enable')}} ' {{$t('Archive to')}} ' {{$t('user action')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateArchiveToUAToggleValue($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="customSwitch2"
                                        :checked='globalSettingsInfo.ARCHIVE_TO_REQUIRED'/>
                                    <label class="custom-control-label" for="customSwitch2"></label>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.ARCHIVE_TO_REQUIRED_desc}}
                                </div>
                            </td>
                        </tr>
                        <tr class='d-flex'>
                                <td class="key-div">{{$t('Folder Archive')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div class="custom-control custom-switch">
                                        <input
                                            v-on:click="updateFolderArchiveConfig($event.target.checked)"
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="folderArchiveConfig"
                                            :checked='globalSettingsInfo.enable_folder_archive'/>
                                        <label class="custom-control-label" for="folderArchiveConfig"></label>
                                    </div>
                                    <div class="config-desc">
                                        {{globalSettingsInfo.enable_folder_archive_desc}}
                                    </div>
                                </td>
                            </tr>
                    </template>
                </template>    
                
                <template>
                    <tr ref="globalSettingsDeletion">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="viewDelectionConfig = !viewDelectionConfig">
                                <svg v-if="viewDelectionConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!viewDelectionConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Deletion')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template v-if="viewDelectionConfig">
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Time To Kill')}} ({{$t('TTK')}})</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                <div class="w-100">
                                    <div class="d-inline-flex">
                                    <span v-if="!isEditting('ttk_del_perm')">{{
                                        globalSettingsInfo.ttk_del_perm
                                    }}<span style="margin-inline-start: 5px;color: #b4b4b4;">{{$t('days')}}</span></span>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('ttk_del_perm')"
                                        v-show="!isEditting('ttk_del_perm')"
                                        class="editIcon"
                                    ></edit-icon>
                                    </div>
                                    <input
                                        v-if="isEditting('ttk_del_perm')"
                                        type="number"
                                        min=0
                                        ref="ttk_del_perm"
                                        @keypress.enter="updateSelectedAsDefaultPool('ttk_del_perm')"
                                        v-model="ttlToDelete"
                                        :placeholder="$t('Enter TTK value')"
                                        class="rounded text-light comm-input-field-style align-input-field"
                                    />
                                </div>
                                <div v-show="isEditting('ttk_del_perm')">
                                    <div class="d-flex">
                                    <save-icon
                                        @click.native="updateSelectedAsDefaultPool('ttk_del_perm')"
                                    ></save-icon>
                                    <cancel-icon
                                        @click.native="cancelEdit()"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.ttk_desc}}
                                </div>
                            </td>
                        </tr>
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Delete proxy hard link')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateProxyHardLinkToggleValue($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="customSwitchPHL"
                                        :checked='globalSettingsInfo.delete_proxy_hard_link'/>
                                    <label class="custom-control-label" for="customSwitchPHL"></label>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.delete_proxy_hard_link_desc}}
                                </div>
                            </td>
                        </tr>

                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Proxy Path')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                <div class="w-100">
                                    <div class="d-inline-flex" v-if="!isEditting('proxy_hard_link_path')">
                                        <span v-if="!globalSettingsInfo.proxy_hard_link_path || (globalSettingsInfo.proxy_hard_link_path  && globalSettingsInfo.proxy_hard_link_path.length <=0 )" class="empty-field-text-styles">NONE</span>
                                        <span v-else style="text-overflow: ellipsis;white-space: nowrap;max-width: 300px;overflow: hidden;" :title="globalSettingsInfo.proxy_hard_link_path">{{
                                            globalSettingsInfo.proxy_hard_link_path
                                        }}</span>
                                        <edit-icon
                                            @click.native="editGlobalSettingsField('proxy_hard_link_path')"
                                            v-show="!isEditting('proxy_hard_link_path')"
                                            class="editIcon"
                                        ></edit-icon>
                                    </div>
                                    <input
                                        v-if="isEditting('proxy_hard_link_path')"
                                        type="text"
                                        min="0"
                                        ref="proxy_hard_link_path"
                                        @keypress.enter="updateSelectedAsDefaultPool('proxy_hard_link_path')"
                                        v-model="proxyHardLinkPath"
                                        :placeholder="$t('Enter Proxy path')"
                                        class="rounded text-light comm-input-field-style align-input-field"
                                    />
                                </div>
                                <div v-show="isEditting('proxy_hard_link_path')">
                                    <div class="d-flex">
                                    <save-icon
                                        @click.native="updateSelectedAsDefaultPool('proxy_hard_link_path')"
                                    ></save-icon>
                                    <cancel-icon
                                        @click.native="cancelEdit()"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.proxy_hard_link_path_desc}}
                                </div>
                            </td>
                        </tr>
                    </template>
                </template>

                <template>
                    <tr ref="globalSettingsLanguage">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="islanguageConfigOpen = !islanguageConfigOpen">
                                <svg v-if="islanguageConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!islanguageConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Language')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template v-if="islanguageConfigOpen">
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Language')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                <div class="w-50">
                                    <div class="d-inline-flex" v-if="!isEditting('language')">
                                        <span v-if="!isEditting('language')">{{
                                            globalSettingsInfo.language ? globalSettingsInfo.language : selectedLanguage
                                        }}</span>
                                        <span v-else-if="!globalSettingsInfo.language" class="empty-field-text-styles">{{selectedLanguage}}</span>
                                        <edit-icon
                                            @click.native="editGlobalSettingsField('language')"
                                            v-show="!isEditting('language')"
                                            class="editIcon"
                                        ></edit-icon>
                                    </div>
                                    <Multiselect
                                        v-if="isEditting('language')"
                                        :value="getLanguageMap(selectedLanguage)"
                                        :options="languagesList"
                                        label="name"
                                        track_by="_id"
                                        :placeholder="$t('Select Language')"
                                        :hideSelected="false"
                                        :close-on-select="true"
                                        deselectLabel=""
                                        selectLabel=""
                                        selectedLabel=""
                                        :showNoOptions="false"
                                        class="align-input-field"
                                        @select="handleLanguageSelection($event)"
                                        ref="dateTimeFormatDropdown"
                                        >
                                        <!-- @open="dropDownOpened" -->
                                        <span slot="noResult">No results.</span>
                                    </Multiselect>
                                </div>
                                <div v-show="isEditting('language')">
                                    <div class="d-flex">
                                    <save-icon
                                        @click.native="updateSelectedAsDefaultPool('language')"
                                    ></save-icon>
                                    <cancel-icon
                                        @click.native="cancelEdit()"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                                <div class="config-desc" style="width: 100%;">
                                    {{globalSettingsInfo.application_language_desc}}
                                </div>
                            </td>   
                        </tr>
                        <tr class='d-flex'>
                                <td class="key-div">{{$t('Enable Global Language option')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div class="custom-control custom-switch">
                                        <input
                                            v-on:click="updateGlobalLanguageSelectConfig($event.target.checked)"
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="globalLanguageConfig"
                                            :checked='globalSettingsInfo.enable_global_language_option'/>
                                        <label class="custom-control-label" for="globalLanguageConfig"></label>
                                    </div>
                                    <div class="config-desc">
                                        {{globalSettingsInfo.enable_global_language_option_desc}}
                                    </div>
                                </td>
                            </tr>
                    </template>    
                </template>    

                <template>
                    <tr ref="globalSettingsDateTime">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="viewDatetimeconfig = !viewDatetimeconfig">
                                <svg v-if="viewDatetimeconfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!viewDatetimeconfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Date and Time configuration')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template v-if="viewDatetimeconfig">
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Date Time format')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div class="d-inline-flex" v-if="!isEditting('datetime_format')">
                                            <span v-if="!isEditting('datetime_format')">{{
                                                globalSettingsInfo.datetime_format ? globalSettingsInfo.datetime_format.label : ""
                                            }}</span>
                                            <span v-else-if="!globalSettingsInfo.datetime_format" class="empty-field-text-styles">{{selectedDateTimeValue}}</span>
                                            <edit-icon
                                                @click.native="editGlobalSettingsField('datetime_format')"
                                                v-show="!isEditting('datetime_format')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <Multiselect
                                            v-if="isEditting('datetime_format')"
                                            v-model="selectedDateTimeValue"
                                            :options="dateTimeOptionsList"
                                            label="label"
                                            track_by="format"
                                            :placeholder="$t('Select date Time Format')"
                                            :hideSelected="false"
                                            :close-on-select="true"
                                            deselectLabel=""
                                            selectLabel=""
                                            selectedLabel=""
                                            :showNoOptions="false"
                                            class="align-input-field"
                                            @select="handleDateTimeFormatSelection($event)"
                                            ref="dateTimeFormatDropdown"
                                            >
                                            <!-- @open="dropDownOpened" -->
                                            <span slot="noResult">No results.</span>
                                        </Multiselect>
                                    </div>
                                    <div v-show="isEditting('datetime_format')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateSelectedAsDefaultPool('datetime_format')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{globalSettingsInfo.datetime_format_desc}}
                                    </div>
                                </td>   
                            </tr>

                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Date format')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div class="d-inline-flex" v-if="!isEditting('date_format')">
                                            <span v-if="!isEditting('date_format')">{{
                                                globalSettingsInfo.date_format ? globalSettingsInfo.date_format.label : ""
                                            }}</span>
                                            <span v-else-if="!globalSettingsInfo.date_format" class="empty-field-text-styles">{{selectedDateTimeValue}}</span>
                                            <edit-icon
                                                @click.native="editGlobalSettingsField('date_format')"
                                                v-show="!isEditting('date_format')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <Multiselect
                                            v-if="isEditting('date_format')"
                                            v-model="selectedDateValue"
                                            :options="dateFormatOptionsList"
                                            label="label"
                                            track_by="format"
                                            :placeholder="$t('Select date Format')"
                                            :hideSelected="false"
                                            :close-on-select="true"
                                            deselectLabel=""
                                            selectLabel=""
                                            selectedLabel=""
                                            :showNoOptions="false"
                                            class="align-input-field"
                                            @select="handleDateFormatSelection($event)"
                                            ref="dateFormatDropdown"
                                            >
                                            <!-- @open="dropDownOpened" -->
                                            <span slot="noResult">No results.</span>
                                        </Multiselect>
                                    </div>
                                    <div v-show="isEditting('date_format')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateSelectedAsDefaultPool('date_format')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{globalSettingsInfo.date_format_desc}}
                                    </div>
                                </td>   

                            </tr>

                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Time Zone')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div class="d-inline-flex" v-if="!isEditting('application_time_zone')">
                                            <span v-if="!isEditting('application_time_zone')">{{
                                                globalSettingsInfo.application_time_zone ? globalSettingsInfo.application_time_zone : ""
                                            }}</span>
                                            <span v-else-if="!globalSettingsInfo.application_time_zone" class="empty-field-text-styles">{{selectedTimeZoneValue}}</span>
                                            <edit-icon
                                                @click.native="editGlobalSettingsField('application_time_zone')"
                                                v-show="!isEditting('application_time_zone')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <Multiselect
                                            v-if="isEditting('application_time_zone')"
                                        :value="getTimeZoneMap(selectedTimeZoneValue)"
                                            :options="timeZonesList"
                                            label="label"
                                            track_by="format"
                                            :placeholder="$t('Select Time zone')"
                                            :hideSelected="false"
                                            :close-on-select="true"
                                            deselectLabel=""
                                            selectLabel=""
                                            selectedLabel=""
                                            :showNoOptions="false"
                                            class="align-input-field"
                                            @select="handleTimeZoneSelection($event)"
                                            ref="timeZoneDropdown"
                                            >
                                            <!-- @open="dropDownOpened" -->
                                            <div style="display: inline-block;max-height: 12px;align-items: center;width: 100%;" slot="option" slot-scope="scope">
                                                <div style="float:inline-start">
                                                    <span>{{scope.option.label}}</span>
                                                </div>
                                                <span style="color: #a5a5a5;margin-inline-start: 10px;font-size: 12px;">( {{ scope.option.value }} )</span>
                                            </div>
                                            <span slot="noResult">No results.</span>
                                        </Multiselect>

                                    </div>
                                    <div v-show="isEditting('application_time_zone')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateSelectedAsDefaultPool('application_time_zone')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{globalSettingsInfo.application_time_zone_desc}}
                                    </div>
                                </td>   

                            </tr>
                    </template>

                </template>    
                                
                <template>
                    <tr ref="globalSettingsReports">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="isReportsConfigOpen = !isReportsConfigOpen">
                                <svg v-if="isReportsConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!isReportsConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Reports')}}</h6>
                            </div>
                        </td>
                    </tr>

                <template v-if="isReportsConfigOpen">
                    <tr class='d-flex'>
                        <td class="key-div">{{$t('Reports Catalog')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div style="max-width: 74%;text-align: initial;">
                                <div style="display:inline-flex; position: relative;">
                                    <span v-if="selectedCategoryName != undefined && selectedCategoryName.length" class="mr-5" style="line-break: anywhere;">{{ selectedCategoryName }}</span>
                                    <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                    <browse-icon v-on:click.native="openCategoryBrowse()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon>
                                </div>
                                <span v-if="selectedCategoryPath.length" class="catalog-path-styles mr-2" style="line-break: anywhere;display: block;">
                                    <span class="text-color mr-1">Path:</span>
                                    {{selectedCategoryPath.replace("catalog://0",'')}}
                                </span>
                            </div>
                            <div class="config-desc" style="width: 100%;">
                                {{globalSettingsInfo.report_download_catalog_path_desc}}
                            </div>
                        </td>
                    </tr>
                    <tr class='d-flex'>
                        <td class="key-div">{{$t('Reports Bin path')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div style="max-width: 74%;text-align: initial;">
                                <div style="display:inline-flex; position: relative;">
                                    <span v-if="![undefined, null].includes(globalSettingsInfo.report_download_bin_path) && globalSettingsInfo.report_download_bin_path.length" class="mr-5" style="line-break: anywhere;">{{ globalSettingsInfo.report_download_bin_path }}</span>
                                    <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                    <browse-icon v-on:click.native="selectedField='report_download_bin_path';openAddBinsBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon>
                                </div>
                            </div>
                            <div class="config-desc" style="width: 100%;">
                                {{globalSettingsInfo.report_download_bin_path_desc}}
                            </div>
                        </td>
                    </tr>
                    <tr class='d-flex'>
                        <td class="key-div">{{$t('Exclude Catalog')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div style="display: inline-flex;align-items: baseline;" class="w-100">
                            <div class="w-75">
                                <div class="d-inline-flex" v-if="!isEditting('exclude_catalog_path')" style="flex-wrap:wrap">
                                    <div v-if="!globalSettingsInfo.exclude_catalog_path_info || globalSettingsInfo.exclude_catalog_path_info.length == 0" class="empty-field-text-styles">NONE</div>
                                    <div v-else v-for="fItem in globalSettingsInfo.exclude_catalog_path_info" :key="fItem" :title="fItem.parent_path && fItem.parent_path.value?fItem.parent_path.value:''" class="search-in-filter-styles catalogs-display-styles">
                                        {{ fItem.catalog_name }}
                                    </div>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('exclude_catalog_path')"
                                        v-show="!isEditting('exclude_catalog_path')"
                                        class="editIcon"
                                    ></edit-icon>
                                </div>
                                <catalog-dropdown ref="catalogMultiPicklist"
                                    v-if="isEditting('exclude_catalog_path')"
                                    :enableCatBrowser="true"
                                    :selectedOptions="globalSettingsInfo.exclude_catalog_path_info"
                                    :browserPermissions="['full-control','read-modify','read-write']"
                                    :allowSingleSelect="false"
                                    :allowSingleSelectFromBrowse="false"
                                    from="TagMetadata"
                                    class="catalogs-multiselect"
                                ></catalog-dropdown>
                            </div>
                            <div v-if="isEditting('exclude_catalog_path')" style="display: flex;align-items: center;    position: relative;inset-inline-end :20px;">
                                <div class="d-flex">
                                <save-icon
                                    @click.native="updateSelectedAsDefaultPool('exclude_catalog_path')"
                                ></save-icon>
                                <cancel-icon
                                    @click.native="cancelEdit()"
                                ></cancel-icon>
                                </div>
                            </div>
                            </div>
                            <div class="config-desc mt-1" style="width: 100%;">
                                {{globalSettingsInfo.exclude_catalog_path_desc}}
                            </div>
                        </td>   
                    </tr>
                    <tr class='d-flex'>
                        <td class="key-div">{{$t('Set Label for Resolution')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div class="custom-control custom-switch">
                                <input
                                    v-on:click="updateLabelForResolution($event.target.checked)"
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="setLabelForResolution"
                                    :checked='globalSettingsInfo.set_label_for_resolution'/>
                                <label class="custom-control-label" for="setLabelForResolution"></label>
                            </div>
                            <div class="config-desc">
                                {{globalSettingsInfo.set_label_for_resolution_desc}}
                            </div>
                        </td>
                    </tr>
                    <!-- <tr class='d-flex'>
                        <td class="key-div">{{$t('Exclude Bin path')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div style="display: inline-flex;align-items: baseline;" class="w-100">
                            <div class="w-75">
                                <div class="d-inline-flex" v-if="!isEditting('exclude_bin_path')" style="flex-wrap:wrap">
                                    <div v-if="!globalSettingsInfo.exclude_bin_path_info || globalSettingsInfo.exclude_bin_path_info.length == 0" class="empty-field-text-styles">NONE</div>
                                    <div v-else v-for="fItem in globalSettingsInfo.exclude_bin_path_info" :key="fItem" :title="fItem.path" class="search-in-filter-styles catalogs-display-styles">
                                        {{ fItem.path }}
                                    </div>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('exclude_bin_path')"
                                        v-show="!isEditting('exclude_bin_path')"
                                        class="editIcon"
                                    ></edit-icon>
                                </div>
                                <bins-dropdown 
                                v-if="isEditting('exclude_bin_path')"
                                :enableFolderBrowser="true" ref="newPath"
                                class="catalogs-multiselect"
                                :selectedFolders="globalSettingsInfo.exclude_bin_path_info"
                                @removedCatalogFromList="handlePathDeletion"
                                @folderSelectionChanged="handlePathSelection" :enableMultiSelect="true" :setDefaultFocus="true"></bins-dropdown>
                            </div>
                            <div v-if="isEditting('exclude_bin_path')" style="display: flex;align-items: center;    position: relative;inset-inline-end :20px;">
                                <div class="d-flex">
                                <save-icon
                                    @click.native="updateSelectedAsDefaultPool('exclude_bin_path')"
                                ></save-icon>
                                <cancel-icon
                                    @click.native="cancelEdit()"
                                ></cancel-icon>
                                </div>
                            </div>
                            </div>
                            <div class="config-desc mt-1" style="width: 100%;">
                                {{globalSettingsInfo.exclude_bin_path_desc}}
                            </div>
                        </td>   
                    </tr> -->
                </template>
            </template>

                <template>
                    <tr ref="globalSettingsReferenceId">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="viewReferenceIDConfig = !viewReferenceIDConfig">
                                <svg v-if="viewReferenceIDConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!viewReferenceIDConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Reference ID')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template  v-if="viewReferenceIDConfig">
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Enable Reference ID workflow')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateEnableBarcodeWorkflow($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="customSwitch9"
                                        :placeholder="$t('Enter the alias of Reference ID')"
                                        :checked='globalSettingsInfo.enable_reference_id_workflow'/>
                                    <label class="custom-control-label" for="customSwitch9"></label>
                                </div>
                                <div class="config-desc">
                                    {{globalSettingsInfo.enable_reference_id_workflow_desc}}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="globalSettingsInfo.enable_reference_id_workflow" class='d-flex'>
                            <td class="key-div">{{$t('Alias of Reference ID')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                <div class="w-100">
                                    <div v-if="!isEditting('alias_name')" class="d-inline-flex">
                                    <span v-if="globalSettingsInfo.alias">{{
                                        globalSettingsInfo.alias.alias_name
                                    }}</span>
                                    <span v-else-if="!globalSettingsInfo.alias || !globalSettingsInfo.alias.alias_name" class="empty-field-text-styles">NONE</span>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('alias_name'),globalSettingsInfo.alias?aliasName = globalSettingsInfo.alias.alias_name:''"
                                        v-show="!isEditting('alias_name')"
                                        class="editIcon"
                                    ></edit-icon>
                                    </div>
                                    <input
                                        v-if="isEditting('alias_name')"
                                        type="text"
                                        min="0"
                                        ref="alias_name"
                                        @keypress.enter="updateAliasOfReferenceId('alias_name')"
                                        v-model="aliasName"
                                        class="rounded text-light comm-input-field-style align-input-field"
                                    />
                                </div>
                                <div v-show="isEditting('alias_name')" >
                                    <div class="d-flex">
                                    <save-icon
                                        @click.native="updateAliasOfReferenceId('alias_name')"
                                    ></save-icon>
                                    <cancel-icon
                                        @click.native="cancelEdit()"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                                <div class="config-desc" >
                                    {{globalSettingsInfo.alias_desc}}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="globalSettingsInfo.enable_reference_id_workflow" class='d-flex'>
                            <td class="key-div">{{$t('Allow Reference ID edit')}} </td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateReferenceIDEditAction($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="customSwitch20"
                                        :placeholder="$t('Enter the alias of Reference ID')"
                                        :checked='globalSettingsInfo.allow_refrence_id_to_edit'/>
                                    <label class="custom-control-label" for="customSwitch20"></label>
                                </div>
                                <div class="config-desc">
                                    {{globalSettingsInfo.allow_refrence_id_to_edit_desc}}
                                </div>
                            </td>
                        </tr>
                    </template>
                </template>
                <!-- HARD SUBCLIPS CONFIG -->
                <template v-if="hardSubclipConfig && Object.keys(hardSubclipConfig).length > 0">
                    <tr ref="globalSettingsSubclips">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="viewHardSubclipsConfig = !viewHardSubclipsConfig">
                                <svg v-if="viewHardSubclipsConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!viewHardSubclipsConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('Subclips')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template v-if="viewHardSubclipsConfig">
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Hard subclips')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateHardSCConfig($event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="hardSubclipConfig"
                                        :checked='hardSubclipConfig.enable_hard_subclips'/>
                                    <label class="custom-control-label" for="hardSubclipConfig"></label>
                                </div>
                                <div class="config-desc">
                                    {{hardSubclipConfig.enable_hard_subclips_desc}}
                                </div>
                            </td>
                        </tr>
                        <template v-if="hardSubclipConfig.enable_hard_subclips">
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Archive children subclip')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div class="custom-control custom-switch">
                                        <input
                                            v-on:click="updateSCArchiveConfig($event.target.checked)"
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="subclipArchiveConfig"
                                            :checked='hardSubclipConfig.archive_subclip_along_with_parent'/>
                                        <label class="custom-control-label" for="subclipArchiveConfig"></label>
                                    </div>
                                    <div class="config-desc">
                                        {{hardSubclipConfig.archive_subclip_along_with_parent_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Default subclip path')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div>
                                        <div class="custom-control custom-switch">
                                            <input
                                                v-on:click="updateSCGlobalPathConfig($event.target.checked)"
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="subclipGlobalPath"
                                                :checked='hardSubclipConfig.select_global_path'/>
                                            <label class="custom-control-label" for="subclipGlobalPath"></label>
                                        </div>
                                        <div class="config-desc">
                                            {{hardSubclipConfig.select_global_path_desc}}
                                        </div>
                                    </div>
                                    <div v-if="hardSubclipConfig && hardSubclipConfig.select_global_path" style="margin-top: 15px;">
                                        <div style="max-width: 74%;text-align: initial;">
                                            <div style="display:inline-flex; position: relative;">
                                                <span v-if="![undefined, null].includes(hardSubclipConfig.global_path) && hardSubclipConfig.global_path.length" class="mr-5" style="line-break: anywhere;">{{ hardSubclipConfig.global_path }}</span>
                                                <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                                <browse-icon v-on:click.native="fileBrowseType='hardSubclips';openAddBinsBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon>
                                            </div>
                                        </div>
                                        <div class="config-desc" style="width: 100%;">
                                            {{hardSubclipConfig.global_path_desc}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Select path during creation')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div class="custom-control custom-switch">
                                        <input
                                            v-on:click="updateSCPathConfig($event.target.checked)"
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="subclipPathConfig"
                                            :checked='hardSubclipConfig.select_path_during_creation'/>
                                        <label class="custom-control-label" for="subclipPathConfig"></label>
                                    </div>
                                    <div class="config-desc">
                                        {{hardSubclipConfig.select_path_during_creation_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex' ref="generalTab">
                                <td class="key-div">{{$t('Profile')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div class="custom-control" style="padding-inline-start: 0px;width: 65%;">
                                        <Multiselect
                                            v-model="profileObj"
                                            :options="transcoderProfiles"
                                            label="profile_name"
                                            track_by="_id"
                                            :placeholder="$t('Select Profile')"
                                            :hideSelected="false"
                                            :close-on-select="true"
                                            deselectLabel=""
                                            selectLabel=""
                                            selectedLabel=""
                                            :showNoOptions="false"
                                            @open="dropDownOpened"
                                            @select="handleTranscodeProfileSelection($event)"
                                            ref="profilesDropdown"
                                            >
                                            <span slot="noResult">No results.</span>
                                        </Multiselect>
                                    </div>
                                    <div class="config-desc">
                                        {{hardSubclipConfig.profile_desc}}
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>
                <!-- END OF HARD SUBCLIPS CONFIG -->
            <!--- Locked Files Config -->
            <template>
                <tr ref="globalSettingsLockedFiles">
                    <td colspan="2">
                        <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                            <button class="btn text-white p-0 pl-2" @click="viewLockedFilesConfig = !viewLockedFilesConfig">
                                <svg v-if="viewLockedFilesConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!viewLockedFilesConfig" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            </button>
                            <h6 class="m-0 text-left">{{$t('Locked Files')}}</h6>
                        </div>
                    </td>
                </tr>
                <template v-if="viewLockedFilesConfig">
                    <tr v-if="globalSettingsInfo.lock_restricted_actions" class='d-flex'>
                        <td class="key-div">{{$t('Restricted actions')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div style="display: inline-flex" class="w-100">
                            <div class="w-75">
                                <div class="d-inline-flex" v-if="!isEditting('lock_restricted_actions')" style="flex-wrap:wrap">
                                    <div v-if="!lockRestrictedActions || lockRestrictedActions.length == 0" class="empty-field-text-styles">NONE</div>
                                    <div v-else v-for="fItem in lockRestrictedActions" :key="fItem._id" class="search-in-filter-styles">
                                        {{ fItem.label }}
                                    </div>
                                    <edit-icon
                                        @click.native="editGlobalSettingsField('lock_restricted_actions')"
                                        v-show="!isEditting('lock_restricted_actions')"
                                        class="editIcon"
                                    ></edit-icon>
                                </div>
                                <Multiselect
                                    v-if="isEditting('lock_restricted_actions')"
                                    v-model="lockRestrictedActions"
                                    :options="filesUserActions"
                                    :placeholder="$t('Select actions')"
                                    :hideSelected="false"
                                    :close-on-select="true"
                                    track-by="_id"
                                    label="label"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :showNoOptions="false"
                                    :multiple="true"
                                    class="align-input-field-assets-search"
                                    ref="lockActionsDropdown"
                                    @remove="lockActionOnRemove($event)"
                                    >
                                    <span slot="noResult">No results.</span>
                                </Multiselect>
                            </div>
                            <div v-if="isEditting('lock_restricted_actions')" style="display: flex;align-items: center;">
                                <div class="d-flex">
                                <save-icon
                                    @click.native="updateSelectedAsDefaultPool('lock_restricted_actions')"
                                ></save-icon>
                                <cancel-icon
                                    @click.native="cancelEdit('lock_restricted_actions')"
                                ></cancel-icon>
                                </div>
                            </div>
                            </div>
                            <div class="config-desc" style="width: 100%;">
                                {{globalSettingsInfo.lock_restricted_actions_desc}}
                            </div>
                        </td>   
                    </tr>
                </template>
            </template>
            <!-- END of Locked Files Config-->

            <!--  Client Branding section --> 
                
                <tr ref="globalSettingsClientBranding">
                    <td colspan="2">
                        <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                            <button class="btn text-white p-0 pl-2" @click="isClientBrandingOpened = !isClientBrandingOpened">
                            <svg v-if="isClientBrandingOpened" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            <svg v-if="!isClientBrandingOpened" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            </button>
                            <h6 class="m-0 text-left">{{$t('Client Branding')}}</h6>
                        </div>
                    </td>
                </tr>

                <!-- <tr class='d-flex' v-if="isClientBrandingOpened">
                    <td class="key-div">Branding Name</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('client_branding_name') && globalSettingsInfo.client_branding_name">{{
                                globalSettingsInfo.client_branding_name
                            }}</span>
                            <span v-else-if="!isEditting('client_branding_name')" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('client_branding_name')"
                                v-if="!isEditting('client_branding_name')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('client_branding_name')"
                                type="text"
                                min="0"
                                ref="client_branding_name"
                                @keypress.enter="updateSelectedAsDefaultPool('client_branding_name')"
                                v-model="clientBrandingName"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-if="isEditting('client_branding_name')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('client_branding_name')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.client_branding_name_desc}}
                        </div>
                    </td>
                </tr> -->

                <tr class='d-flex' v-if="isClientBrandingOpened">
                    <td class="key-div">{{$t('Login page branding logo')}}</td>
                    <td class="value-div w-30 float-left m-0 branding_logo_upload_td">
                        <div style="max-width: 74%;text-align: initial;">
                            <div style="display:inline-flex; position: relative;">
                                <span  v-if="globalSettingsInfo.client_logo && globalSettingsInfo.client_logo.length" class="hover-to-show-delete-icon" style="line-break: anywhere; height: 60px; max-height: 60px; display: inline-block;"> <!-- v-if="globalSettingsInfo.client_logo && globalSettingsInfo.client_logo.length" -->
                                    <img style="height: 100%; border-radius: 5px;" :src="getProxyConvertedURL(globalSettingsInfo.client_logo)"/>
                                    <cancel-icon @click="removeTheImage('client_logo')" class="delete-icon"></cancel-icon>
                                </span>
                                <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                <span title="Change branding logo" class="branding_logo_upload_wrapper ml-2" @click="handleBrandingLogoClick">
                                <!-- <browse-icon  v-on:click.native="openClientBrandLogoSelectionBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon> -->
                                    <input 
                                    style="height:0;width:0;display: none;"
                                    type="file"
                                    id="file"
                                    ref="uploadBrandingLogo"
                                    accept="image/*"
                                    v-on:change="handleBrandingLogoChange($event)"
                                    />
                                <div>
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#878585" viewBox="0 0 16 16" class="bi bi-upload"><path  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path><path  d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"></path></svg>
                                </div>
                                <div style="color: #cbcaca;">
                                    Upload
                                </div>
                                </span>
                            </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.client_logo_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex' v-if="isClientBrandingOpened">
                    <td class="key-div">{{$t('Landing page logo')}}</td>
                    <td class="value-div w-30 float-left m-0 branding_logo_upload_td">
                        <div style="max-width: 74%;text-align: initial;">
                            <div style="display:inline-flex; position: relative;">
                                <span  v-if="globalSettingsInfo.landing_page_logo_web && globalSettingsInfo.landing_page_logo_web.length" class="hover-to-show-delete-icon" style="line-break: anywhere; height: 60px; max-height: 60px; display: inline-block;"> <!-- v-if="globalSettingsInfo.landing_page_logo_web && globalSettingsInfo.landing_page_logo_web.length" -->
                                    <img style="height: 100%; border-radius: 5px;" :src="getProxyConvertedURL(globalSettingsInfo.landing_page_logo_web)"/>
                                    <cancel-icon @click="removeTheImage('landing_page_logo_web')" class="delete-icon"></cancel-icon>
                                </span>
                                <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                <span title="Change branding logo" class="branding_logo_upload_wrapper ml-2" @click="handleWebLandingpageLogoClick">
                                <!-- <browse-icon  v-on:click.native="openClientBrandLogoSelectionBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon> -->
                                    <input 
                                    style="height:0;width:0;display: none;"
                                    type="file"
                                    id="file"
                                    ref="uploadWebLandingPageLogo"
                                    accept="image/*"
                                    v-on:change="handleWebLandingPageLogoChange($event)"
                                    />
                                <div>
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#878585" viewBox="0 0 16 16" class="bi bi-upload"><path  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path><path  d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"></path></svg>
                                </div>
                                <div style="color: #cbcaca;">
                                    Upload
                                </div>
                                </span>
                            </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.landing_page_logo_web_desc}}
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{$t('NOTE: Please upload a logo that fits within 40px × 40px dimensions')}}
                        </div>
                    </td>
                </tr>



                <tr class='d-flex' v-if="isClientBrandingOpened">
                    <td class="key-div">{{$t('Login page Background image')}}</td>
                    <td class="value-div w-30 float-left m-0 branding_logo_upload_td">
                        <div style="max-width: 74%;text-align: initial;">
                            <div style="display:inline-flex; position: relative;">
                                <span  v-if="globalSettingsInfo.login_page_background_image_web && globalSettingsInfo.login_page_background_image_web.length" class="hover-to-show-delete-icon" style="line-break: anywhere; height: 60px; max-height: 60px; display: inline-block;">
                                    <img style="height: 100%; border-radius: 5px;" :src="getProxyConvertedURL(globalSettingsInfo.login_page_background_image_web)"/>
                                    <cancel-icon @click="removeTheImage('login_page_background_image_web')" class="delete-icon"></cancel-icon>
                                </span>
                                <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                <span title="Change branding logo" class="branding_logo_upload_wrapper ml-2" @click="handleLoginPageBackgroundImageClick">
                                <!-- <browse-icon  v-on:click.native="openClientBrandLogoSelectionBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon> -->
                                    <input 
                                    style="height:0;width:0;display: none;"
                                    type="file"
                                    id="file"
                                    ref="uploadLoginPageBackgroundImage"
                                    accept="image/*"
                                    v-on:change="handleLoginPageBackgroundImageChange($event)"
                                    />
                                <div>
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#878585" viewBox="0 0 16 16" class="bi bi-upload"><path  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path><path  d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"></path></svg>
                                </div>
                                <div style="color: #cbcaca;">
                                    {{$t('Upload')}}
                                </div>
                                </span>
                            </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.login_page_background_image_web_desc}}
                        </div>
                         <div class="config-desc" style="width: 100%;">
                            {{$t('Note: Please upload an image with a 16:9 aspect ratio')}}
                        </div>
                    </td>
                </tr>

                <!---  End of Client Branding Support  -->

                <!-------  Preview  ---------->

                <tr ref="globalSettingsPreview">
                    <td colspan="2">
                        <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                            <button class="btn text-white p-0 pl-2" @click="isPreviewConfigOpen = !isPreviewConfigOpen">
                            <svg v-if="isPreviewConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            <svg v-if="!isPreviewConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            </button>
                            <h6 class="m-0 text-left">{{$t('Preview')}}</h6>
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'  v-if="isPreviewConfigOpen">
                    <td class="key-div">{{$t('Disable resolution display for image')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateDisableImageResolutionCOnfig($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="disableImageResolution"
                                :checked='globalSettingsInfo.disable_resolution_display_for_image'/>
                            <label class="custom-control-label" for="disableImageResolution"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.disable_resolution_display_for_image_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'  v-if="isPreviewConfigOpen">
                    <td class="key-div">{{$t('Disable resolution display for video')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateVideoImageResolutionCOnfig($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="disableVideoResolution"
                                :checked='globalSettingsInfo.disable_resolution_display_for_video'/>
                            <label class="custom-control-label" for="disableVideoResolution"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.disable_resolution_display_for_video_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'  v-if="isPreviewConfigOpen">
                    <td class="key-div">{{$t('Display file extension')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateFileExtensionConfig($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="enableFileExt"
                                :checked='globalSettingsInfo.enable_file_extension'/>
                            <label class="custom-control-label" for="enableFileExt"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.enable_file_extension_desc}}
                        </div>
                    </td>
                </tr>

                <!----------End or preview configuration-->


                <!----------End of NLP Configuration------>
                <!----------LDAP Configuration------------>

                <template v-if="LDAPConfig && Object.keys(LDAPConfig).length > 0">
                    <tr ref="globalSettingsLDAP">
                        <td colspan="2">
                            <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                                <button class="btn text-white p-0 pl-2" @click="viewLDAPConfiguration = !viewLDAPConfiguration">
                                <svg v-if="viewLDAPConfiguration" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                <svg v-if="!viewLDAPConfiguration" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </button>
                                <h6 class="m-0 text-left">{{$t('LDAP')}}</h6>
                            </div>
                        </td>
                    </tr>
                    <template v-if="viewLDAPConfiguration">
                        <tr class='d-flex'>
                            <td class="key-div">{{$t('Enable LDAP')}}</td>
                            <td class="value-div w-30 float-left m-0">
                                <div class="custom-control custom-switch">
                                    <input
                                        v-on:click="updateLDAPConfiguration('enable_ldap',$event.target.checked)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="LDAPConfig"
                                        :checked='LDAPConfig.enable_ldap'/>
                                    <label class="custom-control-label" for="LDAPConfig"></label>
                                </div>
                                <div class="config-desc">
                                    {{LDAPConfig.enable_ldap_desc}}
                                </div>
                            </td>
                        </tr>
                        <template v-if="LDAPConfig.enable_ldap">
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Base DN')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div v-if="!isEditting('base_dn')" class="d-inline-flex">
                                            <span v-if="LDAPConfig.base_dn.length">{{
                                                LDAPConfig.base_dn
                                            }}</span>
                                            <span v-else class="empty-field-text-styles">{{$t('NONE')}}</span>
                                            <edit-icon
                                                @click.native="baseDNLDAP = LDAPConfig.base_dn,editGlobalSettingsField('base_dn')"
                                                v-if="!isEditting('base_dn')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <input
                                            v-if="isEditting('base_dn')"
                                            type="text"
                                            min="0"
                                            placeholder="Enter Base DN"
                                            ref="base_dn"
                                            @keypress.enter="updateLDAPConfiguration('base_dn')"
                                            v-model="baseDNLDAP"
                                            class="rounded text-light comm-input-field-style align-input-field"
                                        />
                                    </div>
                                    <div v-if="isEditting('base_dn')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateLDAPConfiguration('base_dn')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="baseDNLDAP = LDAPConfig.base_dn,cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{LDAPConfig.base_dn_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Bind DN')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div v-if="!isEditting('bind_dn')" class="d-inline-flex">
                                            <span v-if="LDAPConfig.bind_dn.length">{{
                                                LDAPConfig.bind_dn
                                            }}</span>
                                            <span v-else class="empty-field-text-styles">{{$t('NONE')}}</span>
                                            <edit-icon
                                                @click.native="bindDNLDAP = LDAPConfig.bind_dn,editGlobalSettingsField('bind_dn')"
                                                v-if="!isEditting('bind_dn')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <input
                                            v-if="isEditting('bind_dn')"
                                            type="text"
                                            placeholder="Enter Bind DN"
                                            min="0"
                                            ref="bind_dn"
                                            @keypress.enter="updateLDAPConfiguration('bind_dn')"
                                            v-model="bindDNLDAP"
                                            class="rounded text-light comm-input-field-style align-input-field"
                                        />
                                    </div>
                                    <div v-if="isEditting('bind_dn')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateLDAPConfiguration('bind_dn')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="bindDNLDAP = LDAPConfig.bind_dn,cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{LDAPConfig.bind_dn_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('Bind password')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100" style="position: relative">
                                        <div v-if="!isEditting('bind_password')" class="d-inline-flex">
                                            <span v-if="LDAPConfig.bind_password.length">***********</span>
                                            <span v-else class="empty-field-text-styles">{{$t('NONE')}}</span>
                                            <edit-icon
                                                @click.native="verifypasswordFieldType = 'password',bindPwdLDAP = LDAPConfig.bind_password,editGlobalSettingsField('bind_password')"
                                                v-if="!isEditting('bind_password')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <input
                                            v-if="isEditting('bind_password')"
                                            :type="verifypasswordFieldType"
                                            min="0"
                                            ref="bind_password"
                                            placeholder="Enter Bind password"
                                            @keypress.enter="updateLDAPConfiguration('bind_password')"
                                            v-model="bindPwdLDAP"
                                            class="rounded text-light comm-input-field-style align-input-field"
                                        />
                                        <svg width="2em" height="1.5em" style="position: absolute; inset-inline-end :3%; bottom: 8px" :style="{ fill: verifypasswordFieldType === 'password' ? '#7a7a7a' : '#eee' }" v-show="isEditting('bind_password')" @click="switchPasswordVisibility()" type="password" viewBox="0 0 16 16" class="bi bi-eye ml-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"/>
                                            <path fill-rule="evenodd" d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                                        </svg>
                                    </div>
                                    <div v-show="isEditting('bind_password')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateLDAPConfiguration('bind_password')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="bindPwdLDAP = LDAPConfig.bind_password,cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{LDAPConfig.bind_password_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('LDAP Host')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div v-if="!isEditting('ldap_host')" class="d-inline-flex">
                                            <span v-if="LDAPConfig.ldap_host.length">{{
                                                LDAPConfig.ldap_host
                                            }}</span>
                                            <span v-else class="empty-field-text-styles">{{$t('NONE')}}</span>
                                            <edit-icon
                                                @click.native="LDAPHost = LDAPConfig.ldap_host,editGlobalSettingsField('ldap_host')"
                                                v-if="!isEditting('ldap_host')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <input
                                            v-if="isEditting('ldap_host')"
                                            type="text"
                                            min="0"
                                            ref="ldap_host"
                                            @keypress.enter="updateLDAPConfiguration('ldap_host')"
                                            v-model="LDAPHost"
                                            placeholder="Enter LDAP Host"
                                            class="rounded text-light comm-input-field-style align-input-field"
                                        />
                                    </div>
                                    <div v-if="isEditting('ldap_host')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateLDAPConfiguration('ldap_host')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="LDAPHost = LDAPConfig.ldap_host,cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{LDAPConfig.ldap_host_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('LDAP Port')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div v-if="!isEditting('ldap_port')" class="d-inline-flex">
                                            <span v-if="LDAPConfig.ldap_port.length">{{
                                                LDAPConfig.ldap_port
                                            }}</span>
                                            <span v-else class="empty-field-text-styles">{{$t('NONE')}}</span>
                                            <edit-icon
                                                @click.native="LDAPPort = LDAPConfig.ldap_port,editGlobalSettingsField('ldap_port')"
                                                v-if="!isEditting('ldap_port')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <input
                                            v-if="isEditting('ldap_port')"
                                            type="text"
                                            min="0"
                                            ref="ldap_port"
                                            placeholder="Enter LDAP Port"
                                            @keypress.enter="updateLDAPConfiguration('ldap_port')"
                                            v-model="LDAPPort"
                                            class="rounded text-light comm-input-field-style align-input-field"
                                        />
                                    </div>
                                    <div v-if="isEditting('ldap_port')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateLDAPConfiguration('ldap_port')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="LDAPPort = LDAPConfig.ldap_port,cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{LDAPConfig.ldap_port_desc}}
                                    </div>
                                </td>
                            </tr>
                            <tr class='d-flex'>
                                <td class="key-div">{{$t('User Base DN')}}</td>
                                <td class="value-div w-30 float-left m-0">
                                    <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div v-if="!isEditting('user_base_dn')" class="d-inline-flex">
                                            <span v-if="LDAPConfig.user_base_dn.length">{{
                                                LDAPConfig.user_base_dn
                                            }}</span>
                                            <span v-else class="empty-field-text-styles">{{$t('NONE')}}</span>
                                            <edit-icon
                                                @click.native="userBaseDNLDAP = LDAPConfig.user_base_dn,editGlobalSettingsField('user_base_dn')"
                                                v-if="!isEditting('user_base_dn')"
                                                class="editIcon"
                                            ></edit-icon>
                                        </div>
                                        <input
                                            v-if="isEditting('user_base_dn')"
                                            type="text"
                                            min="0"
                                            ref="user_base_dn"
                                            placeholder="Enter User Base DN"
                                            @keypress.enter="updateLDAPConfiguration('user_base_dn')"
                                            v-model="userBaseDNLDAP"
                                            class="rounded text-light comm-input-field-style align-input-field"
                                        />
                                    </div>
                                    <div v-if="isEditting('user_base_dn')">
                                        <div class="d-flex">
                                        <save-icon
                                            @click.native="updateLDAPConfiguration('user_base_dn')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="userBaseDNLDAP = LDAPConfig.user_base_dn,cancelEdit()"
                                        ></cancel-icon>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="config-desc" style="width: 100%;">
                                        {{LDAPConfig.user_base_dn_desc}}
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>

                <!----------End of LDAP Configuration------------>


                <!-------------------------Fusion Mobile Configuration-->
                <tr ref="globalSettingsMobile">
                    <td colspan="2">
                        <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                            <button class="btn text-white p-0 pl-2" @click="isMobileConfOpen = !isMobileConfOpen">
                            <svg v-if="isMobileConfOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            <svg v-if="!isMobileConfOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            </button>
                            <h6 class="m-0 text-left">{{$t('Fusion Mobile')}}</h6>
                        </div>
                    </td>
                </tr>
                <tr class='d-flex'  v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('Assets Slideshow')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateSlideShow($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="slideshow"
                                :checked='globalSettingsInfo.enable_slideshow'/>
                            <label class="custom-control-label" for="slideshow"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.enable_slideshow_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex' v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('Show Favourites')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('show_favorites') && globalSettingsInfo.show_favorites">{{
                                globalSettingsInfo.show_favorites
                            }}</span>
                            <span v-else-if="!isEditting('show_favorites')" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('show_favorites')"
                                v-if="!isEditting('show_favorites')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('show_favorites')"
                                type="text"
                                min="0"
                                ref="show_favorites"
                                @keypress.enter="updateSelectedAsDefaultPool('show_favorites')"
                                v-model="favouritesDisplayLevels"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-if="isEditting('show_favorites')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('show_favorites')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.show_favorites_desc}}
                        </div>
                    </td>
                </tr>
                <!-- <tr class='d-flex' v-if="isMobileConfOpen">
                    <td class="key-div">Show Children Assets</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('show_children_assets') && globalSettingsInfo.show_children_assets">{{
                                globalSettingsInfo.show_children_assets
                            }}</span>
                            <span v-else-if="!isEditting('show_children_assets')" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('show_children_assets')"
                                v-if="!isEditting('show_children_assets')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('show_children_assets')"
                                type="text"
                                min="0"
                                ref="show_children_assets"
                                @keypress.enter="updateSelectedAsDefaultPool('show_children_assets')"
                                v-model="childrenAssetsDisplayLevels"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-if="isEditting('show_children_assets')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('show_children_assets')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.show_children_assets_desc}}
                        </div>
                    </td>
                </tr> -->
                <tr class='d-flex' v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('Show Recently viewed')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('show_recently_viewed') && globalSettingsInfo.show_recently_viewed">{{
                                globalSettingsInfo.show_recently_viewed
                            }}</span>
                            <span v-else-if="!isEditting('show_recently_viewed')" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('show_recently_viewed')"
                                v-if="!isEditting('show_recently_viewed')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('show_recently_viewed')"
                                type="text"
                                min="0"
                                ref="show_recently_viewed"
                                @keypress.enter="updateSelectedAsDefaultPool('show_recently_viewed')"
                                v-model="recentlyViewedDisplayLevels"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-if="isEditting('show_recently_viewed')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('show_recently_viewed')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.show_recently_viewed_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'  v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('User-group based catalog display')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateUsergroupBasedCatalogs($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="userGroupCatalogDisplay"
                                :checked='globalSettingsInfo.enable_display_catalogs'/>
                            <label class="custom-control-label" for="userGroupCatalogDisplay"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.enable_display_catalogs_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'  v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('Search view landing page')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateSearchViewInMobileConfig($event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="searchViewWorkflow"
                                :checked='globalSettingsInfo.enable_search_view'/>
                            <label class="custom-control-label" for="searchViewWorkflow"></label>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.enable_search_view_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'  v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('Landing page cover image')}}</td>
                    <td class="value-div w-30 float-left m-0 branding_logo_upload_td">
                        <div style="max-width: 74%;text-align: initial;">
                            <div style="display:inline-flex; position: relative;">
                                <span  v-if="globalSettingsInfo.workspace_background_image && globalSettingsInfo.workspace_background_image.length" class="hover-to-show-delete-icon" style="line-break: anywhere; height: 60px; max-height: 60px; display: inline-block;"> <!-- v-if="globalSettingsInfo.client_logo && globalSettingsInfo.client_logo.length" -->
                                    <img style="height: 100%; border-radius: 5px;" :src="getProxyConvertedURL(globalSettingsInfo.workspace_background_image)"/>
                                    <cancel-icon @click="removeTheImage('workspace_background_image')" class="delete-icon"></cancel-icon>
                                </span>
                                <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                <span title="Change branding logo" class="branding_workspace_logo_wrapper ml-2" @click="handleWorkspaceLogoClick">
                                <!-- <browse-icon  v-on:click.native="openClientBrandLogoSelectionBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon> -->
                                    <input 
                                    style="height:0;width:0;display: none;"
                                    type="file"
                                    id="file"
                                    ref="uploadWorkspaceLogo"
                                    accept="image/*"
                                    v-on:change="handleWorkspaceLogoChange($event)"
                                    />
                                <div>
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#878585" viewBox="0 0 16 16" class="bi bi-upload"><path  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path><path  d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"></path></svg>
                                </div>
                                <div style="color: #cbcaca;">
                                    Upload
                                </div>
                                </span>
                            </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.workspace_background_image_desc}}
                        </div>
                    </td>
                </tr>

                <tr class='d-flex'  v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('Landing page logo')}}</td>
                    <td class="value-div w-30 float-left m-0 branding_logo_upload_td">
                        <div style="max-width: 74%;text-align: initial;">
                            <div style="display:inline-flex; position: relative;">
                                <span  v-if="globalSettingsInfo.landing_page_logo && globalSettingsInfo.landing_page_logo.length" class="hover-to-show-delete-icon" style="line-break: anywhere; height: 60px; max-height: 60px; display: inline-block;"> <!-- v-if="globalSettingsInfo.client_logo && globalSettingsInfo.client_logo.length" -->
                                    <img style="height: 100%; border-radius: 5px;" :src="getProxyConvertedURL(globalSettingsInfo.landing_page_logo)"/>
                                    <cancel-icon @click="removeTheImage('landing_page_logo')" class="delete-icon"></cancel-icon>
                                </span>
                                <span v-else class="empty-field-text-styles mr-2" style="width:65px;">NONE</span>
                                <span title="Change branding logo" class="branding_workspace_logo_wrapper ml-2" @click="handleLandingPageLogoClick">
                                <!-- <browse-icon  v-on:click.native="openClientBrandLogoSelectionBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon> -->
                                    <input 
                                    style="height:0;width:0;display: none;"
                                    type="file"
                                    id="file"
                                    ref="landingPageLogoRef"
                                    accept="image/*"
                                    v-on:change="handleLandingPageLogoChange($event)"
                                    />
                                <div>
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#878585" viewBox="0 0 16 16" class="bi bi-upload"><path  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path><path  d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"></path></svg>
                                </div>
                                <div style="color: #cbcaca;">
                                    Upload
                                </div>
                                </span>
                            </div>
                        </div>
                        <div class="config-desc">
                            {{globalSettingsInfo.landing_page_logo_desc}}
                        </div>
                    </td>
                </tr>
                <tr class='d-flex' v-if="isMobileConfOpen">
                    <td class="key-div">{{$t('Mobile app force logout duration')}}</td>
                    <td class="value-div w-30 float-left m-0">
                        <div style="display: inline-flex" class="w-100">
                        <div class="w-100">
                            <div class="d-inline-flex">
                            <span v-if="!isEditting('mobile_app_force_logout_duration')">{{
                                globalSettingsInfo.mobile_app_force_logout_duration
                            }} minutes</span>
                            <span v-else-if="!isEditting('mobile_app_force_logout_duration') && !globalSettingsInfo.mobile_app_force_logout_duration" class="empty-field-text-styles">NONE</span>
                            <edit-icon
                                @click.native="editGlobalSettingsField('mobile_app_force_logout_duration')"
                                v-show="!isEditting('mobile_app_force_logout_duration')"
                                class="editIcon"
                            ></edit-icon>
                            </div>
                            <input
                                v-if="isEditting('mobile_app_force_logout_duration')"
                                type="number"
                                min="0"
                                ref="mobile_app_force_logout_duration"
                                @keypress.enter="updateSelectedAsDefaultPool('mobile_app_force_logout_duration')"
                                v-model="mobileForceLogoutConfig"
                                class="rounded text-light comm-input-field-style align-input-field"
                            />
                        </div>
                        <div v-show="isEditting('mobile_app_force_logout_duration')">
                            <div class="d-flex">
                            <save-icon
                                @click.native="updateSelectedAsDefaultPool('mobile_app_force_logout_duration')"
                            ></save-icon>
                            <cancel-icon
                                @click.native="cancelEdit()"
                            ></cancel-icon>
                            </div>
                        </div>
                        </div>
                        <div class="config-desc" style="width: 100%;">
                            {{globalSettingsInfo.mobile_app_force_logout_duration_desc}}
                        </div>
                    </td>
                </tr>
                <!------------------------Fusion Mobile Configuration------->

                <!-------  Preview  ---------->

                <tr ref="globalSettingsAI">
                    <td colspan="2">
                        <div  style="display: inline-flex; width: 100%; align-items: center; gap: 12px; margin-inline-start: 27px;">
                            <button class="btn text-white p-0 pl-2" @click="viewAIButtonToolsConfigOpen = !viewAIButtonToolsConfigOpen">
                            <svg v-if="viewAIButtonToolsConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            <svg v-if="!viewAIButtonToolsConfigOpen" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                            </button>
                            <h6 class="m-0 text-left">{{$t('AI')}}</h6>
                        </div>
                    </td>
                </tr>
                <template v-if="viewAIButtonToolsConfigOpen">
                    <tr class='d-flex'>
                        <td class="key-div">{{$t('Enable AI buttons and tools')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div class="custom-control custom-switch">
                                <input
                                    v-on:click="updateDisableAIButtonsCOnfig($event.target.checked)"
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="disableAIButtons"
                                    :checked='globalSettingsInfo.enable_ai_plugin_related_buttons'/>
                                <label class="custom-control-label" for="disableAIButtons"></label>
                            </div>
                            <div class="config-desc">
                                {{globalSettingsInfo.enable_ai_plugin_related_buttons_desc}}
                            </div>
                        </td>
                    </tr>
                </template>

                <!----------End or preview configuration-->
            </tbody>
            </table>
        </div>
    <StopWordsDialog v-if="stopWordsDialog" :stopwords='searchSConfigurations.stop_words' @closeDialog="stopWordsDialog=false" @saveChanges="handleStopwordsUpdate"></StopWordsDialog>
    <bins-browse-modal
      ref="binsBrowseModal"
      v-if="isModalVisible"
      :workspaceList="browseWorkspaceList"
      :enableAssetMultiSelect="enableMultiSelect"
      @close="closeModal"
      @handleFilesBrowse="selectedBinPath"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
      :parentPreSelectedPathIds="getSelectedFieldValue()"
    ></bins-browse-modal>
    <bins-browse-modal
      ref="catalogsBrowseModal"
      v-if="isCategoryBrowse"
      :workspaceList="catalogWorkspaceList"
      :enableAssetMultiSelect="enableMultiSelect"
      @close="closeCatBrowse"
      @handleFilesBrowse="addSelectedCategoryId"
      :enableRecursive="false"
      :browseOnlyFolders="isCatalogFolderSelect"
      style="z-index:99"
      :parentPreSelectedPathIds="getReportsCatalogId()"
    ></bins-browse-modal>
    </div>  
</template>

<script>
import {mapActions, mapMutations, mapGetters} from "vuex";
import {NotifierConstants} from "../../components.constants.js";
import Multiselect from "vue-multiselect";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import fileBrowseModel from "../files/filesBrowse.vue";
import browseIcon from "../core/InlineBrowseField.vue";
import CatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
import StopWordsDialog from "./stopwordDialog.vue";
// import binsDropdown from "../bins/binsFoldersMultiDropdown.vue";

export default {
    data(){
        return{
            validateIpAddress:null,
            globalSettingsInfo:null,
            editingkey:null,
            notifierIP:null,
            secondaryNotifierIP:null,
            notifierEndpointIp:null,
            proxyHardLinkPath:null,
            redirectURL:null,
            ttlToDelete:null,
            elasticSearchIP:null,
            nlpElasticSearchIP:"",
            aliasName:'',
            departmentAliasName:'',
            selectedCategoryPath:"",
            selectedCategoryName:"",
            selectedExcludeCategoryPaths:[],
            selectedExcludeCategoryNames:[],
            selectedExcludeBinPaths:[],
            isCategoryBrowse:false,
            isModalVisible:false,
            catalogWorkspaceList:[Constants.WORKSPACE_CATALOG],
            browseWorkspaceList:[Constants.WORKSPACE_BINS],
            isCatalogFolderSelect: true,
            isClientBrandingOpened: true,
            clientBrandingName: null,
            isMobileConfOpen:true,
            isReportsConfigOpen:true,
            isArchiveConfigOpen:true,
            islanguageConfigOpen:true,
            isPreviewConfigOpen:true,
            favouritesDisplayLevels:null,
            viewHardSubclipsConfig:true,
            viewLDAPConfiguration:true,
            viewNLPConfiguration:true,
            viewReferenceIDConfig:true,
            viewDatetimeconfig:true,
            viewDelectionConfig:true,
            hardSubclipConfig:null,
            searchSConfigurations: null,
            viewBasicConfig:true,
            viewSearchConfig:true,
            viewAIButtonToolsConfigOpen:true,
            fileBrowseType:null,
            transcoderProfiles:[],
            profileObj:[],
            // childrenAssetsDisplayLevels:null,
            recentlyViewedDisplayLevels:null,
            webForceLogoutConfig:0,
            mobileForceLogoutConfig:0,
            dateTimeOptionsList : [],
            dateFormatOptionsList:[],
            timeZonesList:[],
            // languagesList:["English", "Kannada", "French"],
            languagesList:[],
            selectedLanguage:{},
            selectedDateTimeValue:null,
            selectedDateValue:null,
            selectedTimeZoneValue:{},
            searchInKeywordsArr:[],
            searchInFilterValues:[],
            enableMultiSelect:true,
            selectedField:null, 
            LDAPConfig:null,
            enableLDAP:false,
            baseDNLDAP:null,
            bindDNLDAP:null,
            bindPwdLDAP:null,
            LDAPHost:null,
            LDAPPort:null,
            userBaseDNLDAP:null,
            verifypasswordFieldType: "password",
            selectedFilter:"Basic",
            showLeftArrow: false,
            showRightArrow: false,
            canScrollLeft: false,
            canScrollRight: false,
            showArrows:false,
            viewLockedFilesConfig: true,
            lockRestrictedActions:[],
            filesUserActions:[],
            resizeObserver: null,
            selectedFetchFileWithName:null,
            fetchFileWithNameOptions:Constants.FETCH_FILE_AS_OPTIONS,
            selectedNLPModel:null,
            stopWordsDialog: false,
            editedStopWords: [],
            originalStopWords: [],
            nlpServiceIP:null
            // selectedBinPaths:[]
        }
    },
    components: {
        "edit-icon": EditIcon,
        "save-icon": SaveIcon,
        "cancel-icon": CancelIcon,
        "browse-icon" : browseIcon,
        "bins-browse-modal": fileBrowseModel,
        Multiselect,
        "catalog-dropdown":CatalogDropdown,
        StopWordsDialog
        // "bins-dropdown":binsDropdown
    },
    computed:{
        getReadableRedirectURL(){
            if(this.globalSettingsInfo.redirect_url &&
                this.globalSettingsInfo.redirect_url.startsWith("https://")){
                return this.globalSettingsInfo.redirect_url.replace("https://","")
            }
            return "None"
        }
    },
    methods:{
        ...mapActions("settings",["getAssetKeywordSearchInFilters","getGlobalSettingsDetailsFromServer","updateGlobalSettingsKeys", "updateSubclipsGlobalKeys", "gethardSubclipsConfigKeys", "getConfiguredTranscoderProfilesFromServer", "getDateTimeFormatsDropdownValuesFromServer","getDateFormatsDropdownValuesFromServer","getTimezonesDropdownValuesFromServer", "getlangaugesDetailsFromServer","getLDAPConfigurationInfoFromServer",'updateLDAPConfigurationToServer', "getGlobalSearchSettingsDetailsFromServer", "updateGlobalSearchSettingsKeys"]), 
        ...mapActions('upload',['getProxyBinUploadDetails']),
        getProxyConvertedURL(url){
            return Utils.convertToLoginIPDomainName(url);
        },
        handleStopwordsUpdate(editedStopWords) {
            this.stopWordsDialog = false;
            this.searchSConfigurations.stop_words = editedStopWords;
            this.updateSearchSettingsKeys('stop_words')
        },
        getSeparatorLabel(separator) {
            const labels = {
                '-': 'Hyphen ( - )',
                '_': 'Underscore ( _ )'
            };

            return labels[separator] || separator;
        },
        changeFilter(tabName){
            this.selectedFilter = tabName;
            const element = this.$refs['globalSettings'+tabName];
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                element.classList.add('blink');

                setTimeout(() => {
                element.classList.remove('blink');
                }, 1000);
                }
        },

        scrollLeft() {
            const container = this.$refs.filtersContainer;
            if (container) {
                if(!this.isRTL()){
                    container.scrollTo({ left :0, behavior: 'smooth' }); // Scroll to the extreme left
                }else{
                    container.scrollTo({ right :0, behavior: 'smooth' });
                }    
            }
        },
        scrollRight() {
            const container = this.$refs.filtersContainer;
            if (container) {
                const maxScrollLeft = container.scrollWidth - container.clientWidth;
                if(!this.isRTL()){
                    container.scrollTo({ left :maxScrollLeft, behavior: 'smooth' }); // Scroll to the extreme right
                }else{
                    container.scrollTo({ right :maxScrollLeft, behavior: 'smooth' }); // Scroll to the extreme right
                }    
            }
        },
        checkScrollPosition() {
            const container = this.$refs.filtersContainer;
            if (!container) return; // Guard clause to avoid errors
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            // Determine whether scrolling is possible
            this.canScrollLeft = container.scrollLeft > 0;
            this.canScrollRight = maxScrollLeft > 0 && Math.round(container.scrollLeft) < maxScrollLeft;
            // Update arrow visibility
            this.showArrows = maxScrollLeft > 0;
        },
                    
        getSelectedFieldValue(){
            if(this.selectedField && this.selectedField == 'report_download_bin_path'){
                return [this.globalSettingsInfo.report_download_bin_path];
            }else if(this.selectedField && this.selectedField == 'exclude_bin_path'){
                return this.globalSettingsInfo.exclude_bin_path;
            }else{
                return [];
            }
        },
        handlePathSelection(value){
            this.selectedBinPaths.push(value.path)
        },
        handlePathDeletion(value){
            this.selectedBinPaths = this.selectedBinPaths.filter(e => e != value.path)
        },
        removeTheImage(key){
            if(confirm("Are you sure you want to remove the image?")){
                let payload = {};
                payload[key] = "remove";
                payload['_id'] = this.globalSettingsInfo._id;
                this.updateGlobalSettingsKeys(payload).then((data) => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.$toast.success(data.message);
                        this.globalSettingsDataGET();
                        this.assignTheValues();
                    } else {
                        this.$toast.error(data.message);
                        this.assignTheValues();
                    }
                    this.editingkey = null;
                });
            }   
        },
        handleBrandingLogoChange(event){
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => { // convert to base 64
                const base64String = reader.result;
                this.globalSettingsInfo['client_logo'] = base64String;
                this.updateSelectedAsDefaultPool("client_logo");
            };
            reader.readAsDataURL(file); // Convert the file to Base64
        },
        handleWebLandingPageLogoChange(event){
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => { // convert to base 64
                const base64String = reader.result;
                this.globalSettingsInfo['landing_page_logo_web'] = base64String;
                this.updateSelectedAsDefaultPool("landing_page_logo_web");
            };
            reader.readAsDataURL(file); // Convert the file to Base64
        },

        handleLoginPageBackgroundImageChange(event){
            const file = event.target.files[0];
            if (!file) return;
            
            if (!file.type.startsWith("image/")) {
                this.$toast.error("Please select a valid image.");
                return;
            }

            const reader = new FileReader();
            reader.onload = () => { // convert to base 64
                const base64String = reader.result;
                this.globalSettingsInfo['login_page_background_image_web'] = base64String;
                this.updateSelectedAsDefaultPool("login_page_background_image_web");
            };

            reader.onerror = () => {
                this.$toast.error("Failed to read the image.");
            };

            reader.readAsDataURL(file); // Convert the file to Base64
        },
        handleWorkspaceLogoChange(event){
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => { // convert to base 64
                const base64String = reader.result;
                this.globalSettingsInfo['workspace_background_image'] = base64String;
                this.updateSelectedAsDefaultPool("workspace_background_image");
            };
            reader.readAsDataURL(file); // Convert the file to Base64
        },
        handleLandingPageLogoChange(event){
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => { // convert to base 64
                const base64String = reader.result;
                this.globalSettingsInfo['landing_page_logo'] = base64String;
                this.updateSelectedAsDefaultPool("landing_page_logo");
            };
            reader.readAsDataURL(file); // Convert the file to Base64
        },
        handleBrandingLogoClick(){
            this.$refs.uploadBrandingLogo.click();
        },
        handleWorkspaceLogoClick(){
            this.$refs.uploadWorkspaceLogo.click();
        },
        handleLandingPageLogoClick(){
            this.$refs.landingPageLogoRef.click();
        },
        handleWebLandingpageLogoClick(){
            this.$refs.uploadWebLandingPageLogo.click();
        },
        handleLoginPageBackgroundImageClick(){
            this.$refs.uploadLoginPageBackgroundImage.click();
        },
        getReportsCatalogId(){
            let pathList = []
            if('catalog_info' in this.globalSettingsInfo &&
                this.globalSettingsInfo.catalog_info &&
                Object.keys(this.globalSettingsInfo.catalog_info).length > 0){
                pathList.push(this.globalSettingsInfo.catalog_info[0]._id)
            }
            return pathList
        },
        openAddBinsBrowser(isMultiselect=false){
          this.isModalVisible = true;
          this.enableMultiSelect = isMultiselect;
          this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },
        closeModal() {
              this.isModalVisible = false;
              this.$refs.fadeWhenModelOpen.style.opacity = 1;
        },
        selectedBinPath(folderInfoList){
          if(folderInfoList && folderInfoList.length > 0){
            if(this.fileBrowseType && this.fileBrowseType == 'hardSubclips'){
                this.hardSubclipConfig['global_path'] = folderInfoList[0].path;
                this.saveHardSubclipConfigChanges();
            }else 
            // if(this.fileBrowseType && this.fileBrowseType == "exclude_bin_path"){
            //     this.globalSettingsInfo.exclude_bin_path = folderInfoList.map(item => item.path);
            //     this.updateSelectedAsDefaultPool();
            // }else
            {
                this.globalSettingsInfo.report_download_bin_path = folderInfoList[0].path;
                this.updateSelectedAsDefaultPool()
            }
            this.closeModal();
          }else{
            console.log("Failed to update the browsed folder path:",folderInfoList)
          }
        },
        openCategoryBrowse(isMultiselect=false){
            this.isCategoryBrowse = true;
            this.enableMultiSelect = isMultiselect;
            try{
              this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
            }catch(e){console.log(e)}
        },
        closeCatBrowse(){
            this.isCategoryBrowse = false;
            try{
               this.$refs.fadeWhenModelOpen.style.opacity = 1;
            }catch(e){console.log(e)}
        },
        addSelectedCategoryId(browsedCatalogs){
          if(browsedCatalogs && browsedCatalogs.length > 0){
            let selectedPath = browsedCatalogs[0]
            let catId = selectedPath.parent_id_path[0]+ "/" + selectedPath._id;
            this.globalSettingsInfo.report_download_catalog_path = catId;
            this.globalSettingsInfo.catalog_info = [selectedPath]
            this.selectedCategoryPath = selectedPath.parent_path[0].value;
            this.selectedCategoryName = selectedPath.catalog_name;
            this.updateSelectedAsDefaultPool()
            this.closeCatBrowse();
          }else{
            console.log("Failed to update the browsed catalog path:",browsedCatalogs)
          }
        },
        updateCatalogReadOnlyToggleValue(value){
            this.globalSettingsInfo.CATALOG_READ_ONLY = value;
            this.updateSelectedAsDefaultPool();
        },
        updateArchiveToUAToggleValue(value){
            this.globalSettingsInfo.ARCHIVE_TO_REQUIRED = value;
            this.updateSelectedAsDefaultPool();
        },
        updateFolderArchiveConfig(value){
            this.globalSettingsInfo.enable_folder_archive = value;
            this.updateSelectedAsDefaultPool();
        },
        updateGlobalLanguageSelectConfig(value){
            this.globalSettingsInfo.enable_global_language_option = value;
            this.updateSelectedAsDefaultPool();
        },
        updatePasswordEnforcemenToggleValue(value){
            this.globalSettingsInfo.DISABLE_SECURED_PASSWORD_ENFORCEMENT = value;
            this.updateSelectedAsDefaultPool();
        },
        updateSearchAutoCompleteToggleValue(value){
            this.globalSettingsInfo['enable_auto_complete_for_assets_search'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateWildcardSearchToggleValue(value){
            this.globalSettingsInfo['enable_wildcard_search'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateConfDescriptionFScreenToggleValue(value){
            this.globalSettingsInfo['configure_description_from_screen'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateConfCatalogFScreenToggleValue(value){
            this.globalSettingsInfo['configure_catalogs_from_screen'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateMultiCatalogToggleValue(value){
            this.globalSettingsInfo['enable_multi_catalog_browse'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateConfUploadLocationFScreenToggleValue(value){
            this.globalSettingsInfo['configure_upload_location_from_screen'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateResumableUploadToggleValue(value){
            this.globalSettingsInfo['enable_resumable_uploads'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateFolderUploadToggleValue(value){
            this.globalSettingsInfo['enable_folder_upload'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateConfTagsFScreenToggleValue(value){
            this.globalSettingsInfo['configure_tags_from_screen'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateSearchViewInMobileConfig(value){
            this.globalSettingsInfo['enable_search_view'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateSlideShow(value){
            this.globalSettingsInfo['enable_slideshow'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateUsergroupBasedCatalogs(value){
            this.globalSettingsInfo['enable_display_catalogs'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateDisableImageResolutionCOnfig(value){
            this.globalSettingsInfo['disable_resolution_display_for_image'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateVideoImageResolutionCOnfig(value){
            this.globalSettingsInfo['disable_resolution_display_for_video'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateNLPConfiguration(value){
            this.globalSettingsInfo['enable_nlp_search'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateFileExtensionConfig(value){
            this.globalSettingsInfo['enable_file_extension'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateEnableBarcodeWorkflow(value){
            this.globalSettingsInfo['enable_reference_id_workflow'] = value;
            var targetElement = document.getElementById("global_settings_table");
            if (targetElement) {
                var elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                window.scrollTo(0, elementPosition + 200);
            }
            this.updateSelectedAsDefaultPool();
        },
        updateReferenceIDEditAction(value){
            this.globalSettingsInfo['allow_refrence_id_to_edit'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateMediaEditAdvancedControl(value){
           this.globalSettingsInfo['media_edit_advanced_controls'] = value;
           this.updateSelectedAsDefaultPool();
        },
        updateSubclipShowControl(value){
           this.globalSettingsInfo['search_subclips'] = value;
           this.updateSelectedAsDefaultPool();
        },
        updateAssetsCountControl(value){
            this.globalSettingsInfo['enable_assets_tree_count'] = value;
           this.updateSelectedAsDefaultPool();
        },
        updateEnableProjectToggleValue(value){
            this.globalSettingsInfo['enable_department'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateProxyHardLinkToggleValue(value){
            this.globalSettingsInfo['delete_proxy_hard_link'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateAliasOfReferenceId(){
            if(this.aliasName.length > 0){
                this.globalSettingsInfo['alias'] = {
                    "key_name":"reference_id",
                    "alias_name":this.aliasName
                 };
                this.updateSelectedAsDefaultPool();
            }

        },
        updateAliasOfDepartment(){
            if(this.departmentAliasName.length > 0){
                this.globalSettingsInfo['department_alias'] = {
                    "key_name":"department",
                    "alias_name":this.departmentAliasName
                 };
                this.updateSelectedAsDefaultPool();
            }
        },
        updateSeparatorOperators(){
            this.updateSearchSettingsKeys('separator_operators');
        },
        updateSearchSettingsKeys(key){
            let payload = {"_id": this.searchSConfigurations["_id"]};
            payload[key] = this.searchSConfigurations[key];
            this.updateGlobalSearchSettingsKeys(payload).then(data => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
                
            })
        },
        handleTranscodeProfileSelection(profile){
            if(profile){
                this.hardSubclipConfig['profile'] = profile
                this.saveHardSubclipConfigChanges();
            }
        },
        handleDateTimeFormatSelection(option){
            if(option){
                this.selectedDateTimeValue = option;
            }
        },
        handleDateFormatSelection(option){
            if(option){
                this.selectedDateValue = option;
            }
        },
        handleTimeZoneSelection(option){
            if(option){
                this.selectedTimeZoneValue = option.label;
            }
        },
        handleLanguageSelection(option){
            if(option){
                this.selectedLanguage = option.name;
            }
        },
        handleSearchInFiltersSelection(option){
            console.log("optionoption",option)
        },
        dropDownOpened(){
            this.$refs.profilesDropdown.$el.querySelector('.multiselect__content-wrapper').style.setProperty('width',`${this.$refs.generalTab.offsetWidth - 40}px`,'important'); 
        },
        updateHardSCConfig(value){
            this.hardSubclipConfig['enable_hard_subclips'] = value;
            this.saveHardSubclipConfigChanges();
        },
        updateSCArchiveConfig(value){
            this.hardSubclipConfig['archive_subclip_along_with_parent'] = value;
            this.saveHardSubclipConfigChanges();
        },
        updateSCGlobalPathConfig(value){
            this.hardSubclipConfig['select_global_path'] = value;
            this.saveHardSubclipConfigChanges();
        },
        updateSCPathConfig(value){
            this.hardSubclipConfig['select_path_during_creation'] = value;
            this.saveHardSubclipConfigChanges();
        },
        updateLabelForResolution(value){
            this.globalSettingsInfo['set_label_for_resolution'] = value;
            this.updateSelectedAsDefaultPool();
        },
        saveHardSubclipConfigChanges(){
            let payload = {}
            for (const key in this.hardSubclipConfig) {
                if (Object.prototype.hasOwnProperty.call(this.hardSubclipConfig, key) && !key.endsWith('_desc')) {
                    payload[key] = this.hardSubclipConfig[key];
                }
            }
            this.updateSubclipsGlobalKeys(payload).then((data) => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.globalSubclipsConfigFromServer();
                } else {
                    this.$toast.error(data.message);
                }
            });
        },
        updateRememberPassword(value){
            this.globalSettingsInfo['enable_remember_password'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateNofificationFilter(value){
            this.globalSettingsInfo['enable_notification_filtering'] = value;
            this.updateSelectedAsDefaultPool();
        },
        lockActionOnRemove(action){
            this.lockRestrictedActions = this.lockRestrictedActions.filter(e => e._id != action._id)
        },
        updateExportRes(value){
            this.globalSettingsInfo['export_highres_proxy'] = value;
            this.updateSelectedAsDefaultPool();
        },
        handleFetchFileWithNameSelection(option){
            if(option){
                this.selectedFetchFileWithName = option;
            }
        },
        updateDisableAIButtonsCOnfig(value){
            this.globalSettingsInfo['enable_ai_plugin_related_buttons'] = value;
            this.updateSelectedAsDefaultPool();
        },
        updateSelectedAsDefaultPool(updateKeyGlobalSettingsInfo = null){
            console.log("SSSSSSSSSSSSSSSSSSSSSSSSSSSS", updateKeyGlobalSettingsInfo);
          let payload = {};
          payload = {"_id":this.globalSettingsInfo._id,
          "MAIN_ELASTIC_DB_IP":this.elasticSearchIP,
          "NLP_ELASTIC_DB_IP":this.nlpElasticSearchIP.trim(),
          "NLP_SERVICE_IP": this.nlpServiceIP,
          "NOTIFIER_ENDPOINT_IP": this.notifierEndpointIp,
          "MAIN_NOTIFIER_IP":this.notifierIP,
          "SECONDARY_NOTIFIER_IP":this.secondaryNotifierIP,
          "mobile_app_force_logout_duration":parseInt(this.mobileForceLogoutConfig),
          "web_app_force_logout_duration":parseInt(this.webForceLogoutConfig),
          "screen_profile_required":true,
          "show_file_status":true,
          "ttl_to_delete":parseInt(this.ttlToDelete),
          "ttk_del_perm":parseInt(this.ttlToDelete),
          "CATALOG_READ_ONLY": this.globalSettingsInfo.CATALOG_READ_ONLY,
          "ARCHIVE_TO_REQUIRED": this.globalSettingsInfo.ARCHIVE_TO_REQUIRED,
          "DISABLE_SECURED_PASSWORD_ENFORCEMENT": this.globalSettingsInfo.DISABLE_SECURED_PASSWORD_ENFORCEMENT,
          "enable_auto_complete_for_assets_search": this.globalSettingsInfo.enable_auto_complete_for_assets_search,
          "configure_description_from_screen": this.globalSettingsInfo.configure_description_from_screen,
          "configure_catalogs_from_screen": this.globalSettingsInfo.configure_catalogs_from_screen,
          "enable_multi_catalog_browse":this.globalSettingsInfo.enable_multi_catalog_browse,
          "configure_tags_from_screen": this.globalSettingsInfo.configure_tags_from_screen,
          "configure_upload_location_from_screen": this.globalSettingsInfo.configure_upload_location_from_screen,
          "enable_resumable_uploads": this.globalSettingsInfo.enable_resumable_uploads,
          "enable_folder_upload": this.globalSettingsInfo.enable_folder_upload,
          "enable_reference_id_workflow": this.globalSettingsInfo.enable_reference_id_workflow,
          "allow_refrence_id_to_edit": this.globalSettingsInfo.allow_refrence_id_to_edit,
          "report_download_catalog_path":this.globalSettingsInfo.report_download_catalog_path,
          "report_download_bin_path":this.globalSettingsInfo.report_download_bin_path,
          //"client_logo": this.globalSettingsInfo.client_logo,
          "client_branding_name":this.clientBrandingName,
          "media_edit_advanced_controls":this.globalSettingsInfo.media_edit_advanced_controls,
          "show_favorites":this.favouritesDisplayLevels,
        //   "show_children_assets":this.childrenAssetsDisplayLevels,
          "show_recently_viewed":this.recentlyViewedDisplayLevels,
          "enable_search_view": this.globalSettingsInfo.enable_search_view,
          "search_subclips": this.globalSettingsInfo.search_subclips,
          "enable_display_catalogs":this.globalSettingsInfo.enable_display_catalogs,
          "disable_resolution_display_for_image":this.globalSettingsInfo.disable_resolution_display_for_image,
          "disable_resolution_display_for_video":this.globalSettingsInfo.disable_resolution_display_for_video,
          "enable_file_extension": this.globalSettingsInfo.enable_file_extension,
          "enable_slideshow":this.globalSettingsInfo.enable_slideshow,
          "enable_assets_tree_count": this.globalSettingsInfo.enable_assets_tree_count,
          "enable_department": this.globalSettingsInfo.enable_department,
          "datetime_format":this.selectedDateTimeValue,
          "date_format":this.selectedDateValue,
          "application_time_zone":this.selectedTimeZoneValue,
          "application_language": this.selectedLanguage,
          "enable_folder_archive":this.globalSettingsInfo.enable_folder_archive,
          "enable_global_language_option":this.globalSettingsInfo.enable_global_language_option,
          "delete_proxy_hard_link":this.globalSettingsInfo.delete_proxy_hard_link,
          "proxy_hard_link_path":this.proxyHardLinkPath,
          "enable_remember_password":this.globalSettingsInfo.enable_remember_password,
          "fetch_file_with_name":this.selectedFetchFileWithName,
          "export_highres_proxy":this.globalSettingsInfo.export_highres_proxy,
          "enable_notification_filtering":this.globalSettingsInfo.enable_notification_filtering,
          "set_label_for_resolution":this.globalSettingsInfo.set_label_for_resolution,
          "enable_wildcard_search":this.globalSettingsInfo.enable_wildcard_search,
          "enable_ai_plugin_related_buttons":this.globalSettingsInfo.enable_ai_plugin_related_buttons,
          "enable_nlp_search":this.globalSettingsInfo.enable_nlp_search,
          "selected_model_for_nlp":this.selectedNLPModel
        //   "exclude_bin_path":this.selectedBinPaths
          };

          if(updateKeyGlobalSettingsInfo == "exclude_catalog_path" && this.$refs.catalogMultiPicklist && this.$refs.catalogMultiPicklist.getSelectedCatalogId()){
            payload["exclude_catalog_path"] = this.$refs.catalogMultiPicklist.getSelectedCatalogId();
          }
          if(updateKeyGlobalSettingsInfo == 'landing_page_logo_web' && updateKeyGlobalSettingsInfo && String(updateKeyGlobalSettingsInfo).length && this.globalSettingsInfo[updateKeyGlobalSettingsInfo]){
            payload = {"_id":this.globalSettingsInfo._id};
            payload['landing_page_logo_web'] = this.globalSettingsInfo['landing_page_logo_web'];
          }
          if(updateKeyGlobalSettingsInfo == 'login_page_background_image_web' && updateKeyGlobalSettingsInfo && String(updateKeyGlobalSettingsInfo).length && this.globalSettingsInfo[updateKeyGlobalSettingsInfo]){
            payload = {"_id":this.globalSettingsInfo._id};
            payload['login_page_background_image_web'] = this.globalSettingsInfo['login_page_background_image_web'];
          }
          if(updateKeyGlobalSettingsInfo == 'client_logo' && updateKeyGlobalSettingsInfo && String(updateKeyGlobalSettingsInfo).length && this.globalSettingsInfo[updateKeyGlobalSettingsInfo]){
            payload = {"_id":this.globalSettingsInfo._id};
            payload['client_logo'] = this.globalSettingsInfo['client_logo'];
          }
          if(updateKeyGlobalSettingsInfo == 'workspace_background_image' && updateKeyGlobalSettingsInfo && String(updateKeyGlobalSettingsInfo).length && this.globalSettingsInfo[updateKeyGlobalSettingsInfo]){
            payload = {"_id":this.globalSettingsInfo._id};
            payload['workspace_background_image'] = this.globalSettingsInfo['workspace_background_image'];
          }
          if(updateKeyGlobalSettingsInfo == 'landing_page_logo' && updateKeyGlobalSettingsInfo && String(updateKeyGlobalSettingsInfo).length && this.globalSettingsInfo[updateKeyGlobalSettingsInfo]){
            payload = {"_id":this.globalSettingsInfo._id};
            payload['landing_page_logo'] = this.globalSettingsInfo['landing_page_logo'];
          }
          if(this.globalSettingsInfo.enable_reference_id_workflow){
            payload["alias"] = this.globalSettingsInfo.alias;
          }
          if(this.globalSettingsInfo.asset_global_keyword_search_filters){
            payload["asset_global_keyword_search_filters"] = this.searchInFilterValues;
          }
          if(this.globalSettingsInfo.allow_refrence_id_to_edit){
            payload["allow_refrence_id_to_edit"] = this.globalSettingsInfo.allow_refrence_id_to_edit;
          }
          if(this.globalSettingsInfo.enable_department){
            payload["department_alias"] = this.globalSettingsInfo.department_alias;
          }
          if(this.redirectURL && this.redirectURL.startsWith("https://")){
            payload["redirect_url"] = this.redirectURL
          }else{
            payload["redirect_url"] = "https://" + this.redirectURL
          }
          if(this.globalSettingsInfo.lock_restricted_actions){
            let actionIdList = []
            if (this.lockRestrictedActions && this.lockRestrictedActions.length > 0){
                actionIdList = this.lockRestrictedActions.map(item => item._id)
            }
            payload["lock_restricted_actions"] = actionIdList;
          }
          this.updateGlobalSettingsKeys(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.globalSettingsDataGET();
                    this.assignTheValues();
                } else {
                    this.$toast.error(data.message);
                    this.assignTheValues();
                }
                this.editingkey = null;
            });
        },
        isEditting(keyname){
            return keyname === this.editingkey;
        },
        editGlobalSettingsField(keyname){
            if (keyname === 'stop_words') {
                this.originalStopWords = [
                    ...(this.searchSConfigurations.stop_words || [])
                ];

                this.editedStopWords = [
                    ...(this.searchSConfigurations.stop_words || [])
                ];

                this.stopWordsDialog = true;
                return
            }
            this.editingkey = keyname;
            this.assignTheValues();
            setTimeout(() => {
                this.$refs[keyname].focus();
            }, 200)
        },
        cancelEdit(key = null){
            this.editingkey = null;
            if(key && key == 'lock_restricted_actions'){
                this.lockRestrictedActions = this.filesUserActions.filter(action=>this.globalSettingsInfo.lock_restricted_actions.includes(action._id));
            }
        },
        assignTheValues(){
            this.proxyHardLinkPath = this.globalSettingsInfo.proxy_hard_link_path;
            this.notifierEndpointIp = this.globalSettingsInfo.NOTIFIER_ENDPOINT_IP;
            this.notifierIP = this.globalSettingsInfo.MAIN_NOTIFIER_IP;
            this.elasticSearchIP = this.globalSettingsInfo.MAIN_ELASTIC_DB_IP;
            this.nlpServiceIP = this.globalSettingsInfo.NLP_SERVICE_IP;
            this.secondaryNotifierIP = this.globalSettingsInfo.SECONDARY_NOTIFIER_IP;
            this.nlpElasticSearchIP = this.globalSettingsInfo.NLP_ELASTIC_DB_IP || "";
            this.webForceLogoutConfig = this.globalSettingsInfo.web_app_force_logout_duration?this.globalSettingsInfo.web_app_force_logout_duration:0;
            this.mobileForceLogoutConfig = this.globalSettingsInfo.mobile_app_force_logout_duration?this.globalSettingsInfo.mobile_app_force_logout_duration:0;
            this.ttlToDelete = this.globalSettingsInfo.ttk_del_perm;
            this.redirectURL = this.globalSettingsInfo.redirect_url.replace("https://","");
            this.clientBrandingName = this.globalSettingsInfo.client_branding_name;
            this.favouritesDisplayLevels = this.globalSettingsInfo.show_favorites;
            // this.childrenAssetsDisplayLevels = this.globalSettingsInfo.show_children_assets;
            this.recentlyViewedDisplayLevels = this.globalSettingsInfo.show_recently_viewed;
            if(this.globalSettingsInfo.asset_global_keyword_search_filters){
                this.searchInFilterValues = this.globalSettingsInfo.asset_global_keyword_search_filters;
            }
            if(this.globalSettingsInfo.department_alias){
                this.departmentAliasName = this.globalSettingsInfo.department_alias.alias_name
            }

            this.selectedDateTimeValue = this.globalSettingsInfo["datetime_format"];
            this.selectedDateValue = this.globalSettingsInfo["date_format"];
            // this.selectedTimeZoneValue = this.getTimeZoneMap(this.globalSettingsInfo["time_zone"]);
            this.selectedTimeZoneValue = this.globalSettingsInfo["application_time_zone"];
            this.selectedLanguage = this.globalSettingsInfo["application_language"];
            // if(this.globalSettingsInfo["exclude_bin_path"]){
            //     this.selectedBinPaths = this.globalSettingsInfo["exclude_bin_path"];
            // }
            if(this.globalSettingsInfo.lock_restricted_actions && this.globalSettingsInfo.lock_restricted_actions.length > 0){
                this.lockRestrictedActions = this.filesUserActions.filter(action=>this.globalSettingsInfo.lock_restricted_actions.includes(action._id));
            }else{
                this.lockRestrictedActions = []
            }
            this.selectedFetchFileWithName = this.globalSettingsInfo["fetch_file_with_name"];
            this.selectedNLPModel = this.globalSettingsInfo["selected_model_for_nlp"];
            // this.$nextTick(() => {
            //     const container = this.$refs.filtersContainer;
            //     if (container) {
            //     setTimeout(() => {
            //         this.checkScrollPosition(); // Recheck after rendering
            //     }, 200); // Short delay to ensure dimensions are ready
            //     }
            // });
            this.$nextTick(() => {
                this.observeResize();
            })
        },

        getDateTimeFormatMap(dateTimeForamt){
            let dateTimeIndex = this.dateTimeOptionsList.findIndex(op=>op.format_ISO == dateTimeForamt);
            return this.dateTimeOptionsList[dateTimeIndex];
        },

        getDateFormatMap(dateFormat){
            let dateIndex = this.dateFormatOptionsList.findIndex(op=>op.format_ISO == dateFormat);
            return this.dateFormatOptionsList[dateIndex];
        },
        getTimeZoneMap(timeZoneValue){
            let timeZoneIndex = this.timeZonesList.findIndex(op=>op.label == timeZoneValue);
            return this.timeZonesList[timeZoneIndex];
        },

        getLanguageMap(languageName){
            let languageIndex = this.languagesList.findIndex((op)=>op.name == languageName);
            return this.languagesList[languageIndex];
        },
        
        globalSettingsDataGET(){
            this.getGlobalSettingsDetailsFromServer().then((data)=>{
                this.globalSettingsInfo = data.global_settings[0];
                if(!('NOTIFIER_ENDPOINT_IP' in this.globalSettingsInfo)){
                    if(this.globalSettingsInfo && 'MAIN_NOTIFIER_IP' in this.globalSettingsInfo && this.globalSettingsInfo.MAIN_NOTIFIER_IP){
                        this.globalSettingsInfo['NOTIFIER_ENDPOINT_IP'] = this.globalSettingsInfo.MAIN_NOTIFIER_IP
                    } else {
                        this.globalSettingsInfo['NOTIFIER_ENDPOINT_IP'] = '127.0.0.1'
                    }
                    this.globalSettingsInfo['NOTIFIER_ENDPOINT_IP_desc'] = "Local cluster IP for backend-to-notifier communication. This is the primary endpoint and should be configured whenever possible."
                }
                if(!('DISABLE_SECURED_PASSWORD_ENFORCEMENT' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['DISABLE_SECURED_PASSWORD_ENFORCEMENT'] = false
                    this.globalSettingsInfo['DISABLE_SECURED_PASSWORD_ENFORCEMENT_desc'] = "On enabling this, password enforcement will not be checked (i.e Capital /special char / 8 char etc)"
                }
                if(!('enable_auto_complete_for_assets_search' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_auto_complete_for_assets_search'] = true
                    this.globalSettingsInfo['enable_auto_complete_for_assets_search_desc'] = "On enabling this, user will get auto suggestion on typing keyword during assets search"
                }
                if(!('configure_description_from_screen' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['configure_description_from_screen'] = false
                    this.globalSettingsInfo['configure_description_from_screen_desc'] = "On enabling this, description field can be configurable from screen"
                }
                if(!('configure_catalogs_from_screen' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['configure_catalogs_from_screen'] = false
                    this.globalSettingsInfo['configure_catalogs_from_screen_desc'] = "On enabling this, catalogs field can be configurable from screen"
                }
                if(!('enable_multi_catalog_browse' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_multi_catalog_browse'] = true
                    this.globalSettingsInfo['enable_multi_catalog_browse_desc'] = "On enabling this, Multi catalog selection will be allowed in asset details update screen"
                }
                if(!('configure_tags_from_screen' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['configure_tags_from_screen'] = false
                    this.globalSettingsInfo['configure_tags_from_screen_desc'] = "On enabling this, tags field can be configurable from screen"
                }
                if(!('configure_upload_location_from_screen' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['configure_upload_location_from_screen'] = false
                    this.globalSettingsInfo['configure_upload_location_from_screen_desc'] = "On enabling this, upload path field can be configurable from screen"
                }
                if(!('enable_resumable_uploads' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_resumable_uploads'] = false
                    this.globalSettingsInfo['enable_resumable_uploads_desc'] = "On enabling this, resumable uploads will be enabled for large files"
                }
                if(!('enable_folder_upload' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_folder_upload'] = false
                    this.globalSettingsInfo['enable_folder_upload_desc'] = "On enabling this, folder upload will be enabled in upload screen"
                }
                if(!('report_download_catalog_path' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['report_download_catalog_path'] = null
                    this.globalSettingsInfo['report_download_catalog_path_desc'] = "Default catalog path to view the downloaded reports"
                }else if(this.globalSettingsInfo.catalog_info && this.globalSettingsInfo.catalog_info.length>0){
                    let catalogInfo = this.globalSettingsInfo.catalog_info[0];
                    this.selectedCategoryName = catalogInfo.catalog_name;
                    this.selectedCategoryPath = catalogInfo.parent_path["value"]
                }
                if(!('report_download_bin_path' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['report_download_bin_path'] = null
                    this.globalSettingsInfo['report_download_bin_path_desc'] = "Default bin path to view the downloaded reports"
                }
                if(!('client_logo' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['client_logo'] = null
                    this.globalSettingsInfo['client_logo_desc'] = "Branding logo displayed in the application"
                }
                if(!('client_branding_name' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['client_branding_name'] = null
                    this.globalSettingsInfo['client_branding_name_desc'] = "Brand Name to show below branding name"
                }
                if(!('workspace_background_image' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['workspace_background_image'] = null
                    this.globalSettingsInfo['workspace_background_image_desc'] = "Landing page background cover image for mobile app"
                }
                if(!('enable_search_view' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_search_view'] = null
                    this.globalSettingsInfo['enable_search_view_desc'] = "On enabling this, search view will be enabled instead of browse view in mobile app"
                }
                if(!('landing_page_logo' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['landing_page_logo'] = null
                    this.globalSettingsInfo['landing_page_logo_desc'] = "Landing page logo for mobile app"
                }
                if(!('search_subclips' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['search_subclips'] = null
                    this.globalSettingsInfo['search_subclips_desc'] = "On enabling this, search will include subclips in Catalog workspace"
                }
                if(!('enable_display_catalogs' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_display_catalogs'] = null
                    this.globalSettingsInfo['enable_display_catalogs_desc'] = "On enabling this, display catalogs will be shown in mobile app based on User-group configuration"
                }
                if(!('disable_resolution_display_for_image' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['disable_resolution_display_for_image'] = null
                    this.globalSettingsInfo['disable_resolution_display_for_image_desc'] = "On enabling this, resolution will not be displayed for image files"
                }
                if(!('disable_resolution_display_for_video' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['disable_resolution_display_for_video'] = null
                    this.globalSettingsInfo['disable_resolution_display_for_video_desc'] = "On enabling this, resolution will not be displayed for video files"
                }
                if(!('enable_file_extension' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_file_extension'] = false;
                    this.globalSettingsInfo['enable_file_extension_desc'] = "Enabling this will displays file extension along with slugname in Bins ans Catalogs workspace. Ex: .png, .mp4, .mov";
                }
                if(!('enable_slideshow' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_slideshow'] = true;
                    this.globalSettingsInfo['enable_slideshow_desc'] = "On enabling this, slideshow will be displayed in Catalog workspace";
                }
                if(!('enable_assets_tree_count' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_assets_tree_count'] = false
                }
                if(!('enable_assets_tree_count_desc' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_assets_tree_count_desc'] = "On enabling this, Assets and Catalog count will be displayed for each catalog in Catalog workspace."
                }
                if(!('datetime_format_desc' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['datetime_format_desc'] = "Date-time format to show throught the application. Ex 01 Jan 2024 12:00:00."
                }
                if(!('delete_proxy_hard_link' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['delete_proxy_hard_link'] = false;
                    this.globalSettingsInfo['delete_proxy_hard_link_desc'] = "On enabling this, proxy hard links will be deleted along with the asset";
                }
                if(!('proxy_hard_link_path' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['proxy_hard_link_path'] = "";
                    this.globalSettingsInfo['proxy_hard_link_path_desc'] = "Path where proxy hard links will be created.  Ex: share://PROXY";
                }
                if(!('enable_remember_password' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_remember_password'] = false;
                    this.globalSettingsInfo['enable_remember_password_desc'] = "On enabling this, remember password feature will be enabled";
                }
                if(!('lock_restricted_actions' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['lock_restricted_actions'] = [];
                    this.globalSettingsInfo['lock_restricted_actions_desc'] = "Restrict useractions for locked files";
                }
                if(!('fetch_file_with_name' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['fetch_file_with_name'] = "Slugname";
                    this.globalSettingsInfo['fetch_file_with_name_desc'] = "While fetching files(Ex: Retrieve, Download, Proxy-Export), it can be fetched with either 'Filename' or 'Slugname'";
                }
                if(!('export_highres_proxy' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['export_highres_proxy'] = false;
                    this.globalSettingsInfo['export_highres_proxy_desc'] = "Enabling this will allow users to Download, Export high-resolution proxies instead of low-resolution proxies";
                }
                if(!('enable_notification_filtering' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_notification_filtering'] = false;
                    this.globalSettingsInfo['enable_notification_filtering_desc'] = "Enabling this will filter notifications based user permission and previlage";
                }
                if(!('set_label_for_resolution' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['set_label_for_resolution'] = false;
                    this.globalSettingsInfo['set_label_for_resolution_desc'] = "On enabling this, file resolution will be set as asset label on ingest, Ex:SD, HD, FHD, 4K";
                }
                if(!('enable_wildcard_search' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_wildcard_search'] = false
                    this.globalSettingsInfo['enable_wildcard_search_desc'] = "On enabling this, metadata will be saved in untoken form in elasticsearch to support wildcard search"
                }
                if(!('enable_ai_plugin_related_buttons' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_ai_plugin_related_buttons'] = true
                    this.globalSettingsInfo['enable_ai_plugin_related_buttons_desc'] = "Enabling this will hide AI plugin specific buttons and tools depends on user privilege."
                }
                if(!('enable_nlp_search' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_nlp_search'] = false
                    this.globalSettingsInfo['enable_nlp_search_desc'] = "Enabling this will activate NLP-based search to enhance semantic search and relevance ranking."
                }
                if(!('selected_model_for_nlp' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['selected_model_for_nlp'] = ''
                    this.globalSettingsInfo['selected_model_for_nlp_desc'] = this.$t("To Choose the NLP embedding model for semantic search and relevance ranking.Supported options: bge_m3")
                }
                if(!('NLP_SERVICE_IP' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['NLP_SERVICE_IP'] = null
                    this.globalSettingsInfo['NLP_SERVICE_IP_desc'] = "IP used by the semantic search vector service (embedding generation and vector search)."
                }
                // if(!('exclude_bin_path' in this.globalSettingsInfo)){
                //     this.globalSettingsInfo['exclude_bin_path'] = [];
                // }
                

                //******* hardcoded for now*********** */
                    // this.globalSettingsInfo['date_format']="%d %b %Y",
                    // this.globalSettingsInfo['application_time_zone'] = "Asia/Kolkata",
                //******************** */
                this.assignTheValues()
            })
        },
        globalSubclipsConfigFromServer(){
            this.gethardSubclipsConfigKeys().then((data)=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    if(data.subclip_settings && data.subclip_settings.length > 0){
                        this.hardSubclipConfig = data.subclip_settings[0]
                        if('profile' in this.hardSubclipConfig && this.hardSubclipConfig.profile){
                            this.profileObj = this.hardSubclipConfig.profile;
                        }
                    }
                }
            })
        },

        //---------------LDAP CONFIG STARTS---------------

        globalLDAPConfigFromServer(){
            this.getLDAPConfigurationInfoFromServer().then((data)=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    if(data.ldap_settings && data.ldap_settings.length > 0){
                        this.LDAPConfig = data.ldap_settings[0]
                    }
                }
            })
        },

        switchPasswordVisibility(){
            this.verifypasswordFieldType = this.verifypasswordFieldType === 'password' ? 'text' : 'password';
        },

        updateLDAPConfiguration(key,value){
            let payload = {};
            let paramsInfo = {};
            if(key == 'enable_ldap')paramsInfo[key] = value;
            if(key == 'base_dn')paramsInfo[key] = this.baseDNLDAP;
            if(key == 'bind_dn')paramsInfo[key] = this.bindDNLDAP;
            if(key == 'bind_password')paramsInfo[key] = this.bindPwdLDAP;
            if(key == 'ldap_host')paramsInfo[key] = this.LDAPHost;
            if(key == 'ldap_port')paramsInfo[key] = this.LDAPPort;
            if(key == 'user_base_dn')paramsInfo[key] = this.userBaseDNLDAP;
            paramsInfo['id'] = this.LDAPConfig._id;
            payload['params'] = paramsInfo;
            this.updateLDAPConfigurationToServer(payload).then((data) => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
                this.editingkey = null;
            });
        },

        //-----------------LDAP CONFIG ENDS---------------

        getDateTimeFormatDropdownList(){
            this.getDateTimeFormatsDropdownValuesFromServer().then((data)=>{
                this.dateTimeOptionsList = data.datetime_format;
            });
        },

        getDateFormatDropdownList(){
            this.getDateFormatsDropdownValuesFromServer().then((data)=>{
                this.dateFormatOptionsList = data.date_format;
            });
        },

        getApplicationTimeZonesDropdownList(){
            this.getTimezonesDropdownValuesFromServer().then((data)=>{
                this.timeZonesList = data.time_zones;
            });
        },

        getActiveLanguagesList(){
            // let payload = {};
            let payload = {"enabled":true};
            this.getlangaugesDetailsFromServer(payload).then((data)=>{
                this.languagesList = data["languages"];
            });
        },

        getSearchInKeywordsList(){
            this.getAssetKeywordSearchInFilters().then((data)=>{
                this.searchInKeywordsArr = data['filters']
            })
        },
        updateGlobalSettingOnNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
            if(Object.keys(notification.message).includes('enable_file_extension')){
                if(!('enable_file_extension' in this.globalSettingsInfo)){
                    this.globalSettingsInfo['enable_file_extension'] = false;
                    this.globalSettingsInfo['enable_file_extension_desc'] = "Enabling this will displays file extension along with slugname in Bins ans Catalogs workspace. Ex: .png, .mp4, .mov";
                }else{
                    this.globalSettingsInfo['enable_file_extension'] = notification.message.enable_file_extension;
                }
            }
        },
        updateLDAPConfigurations(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
            if(Object.keys(notification.message)){
                this.LDAPConfig.base_dn = notification.message.base_dn;
                this.LDAPConfig.bind_dn = notification.message.bind_dn;
                this.LDAPConfig.bind_password = notification.message.bind_password;
                this.LDAPConfig.ldap_host = notification.message.ldap_host;
                this.LDAPConfig.ldap_port = notification.message.ldap_port;
                this.LDAPConfig.user_base_dn = notification.message.user_base_dn;
                this.LDAPConfig.enable_ldap = notification.message.enable_ldap;
            }
        },
        updateSearchSettingOnNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
            if (notification.message && Object.keys(notification.message).length > 0) {
                const filteredMessage = Object.fromEntries(
                    Object.entries(notification.message).filter(([, value]) => value !== null)
                );

                this.searchSConfigurations = {
                    ...this.searchSConfigurations,
                    ...filteredMessage
                };
            }
        },
        observeResize(){
            const container = this.$refs.filtersContainer;
            if (!container) return;
            // Initialize ResizeObserver
            this.$nextTick(() => {
                this.resizeObserver = new ResizeObserver(() => {
                    this.checkScrollPosition(); // Recalculate scroll states when resized
                });

                if(this.resizeObserver)this.resizeObserver.observe(container);
                // Initial check
                this.checkScrollPosition();
            })
        },
        registerWebsocketNotifier(){
            this.addWSEventListener({eventname:NotifierConstants.searchSettingsUpdatedNotification, callback:this.updateSearchSettingOnNotification, parent:"GlobalSettings"});
            this.addWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingOnNotification, parent:"GlobalSettings"});
            this.addWSEventListener({eventname:NotifierConstants.LDAPUpdatedNotification, callback:this.updateLDAPConfigurations, parent:"GlobalSettings"});
        },
        unRegisterWebsocketNotifier(){
            this.removeWSEventListener({eventname:NotifierConstants.searchSettingsUpdatedNotification, callback:this.updateSearchSettingOnNotification, parent:"GlobalSettings"});
            this.removeWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingOnNotification, parent:"GlobalSettings"});
            this.removeWSEventListener({eventname:NotifierConstants.LDAPUpdatedNotification, callback:this.updateLDAPConfigurations, parent:"GlobalSettings"});
            
        },
        loadFilesUserActions(){
            this.filesUserActions = this.getActionListFromInMem().filter(action=>(action.supported_resources.includes('assets') ||
                                                                                    action.supported_resources.includes('files')) &&
                                                                                    !['Lock','Unlock'].includes(action.label)
                                                                        )
            //Extend useractions with Export and Export Proxy actions, as they are not registered
            this.filesUserActions = this.filesUserActions.concat([{"_id":"Export", "label":"Export"},{"_id":"Export Proxy", "label":"Export Proxy"}])
        },
        ...mapGetters("privileges",["getActionListFromInMem"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener", "unsetWebsocket"]),
    },
    created(){
        // this.getDateTimeFormatDropdownList();
        // this.getDateFormatDropdownList();
        // this.getApplicationTimeZonesDropdownList();
        this.loadFilesUserActions();
        this.globalSettingsDataGET();
        this.$nextTick(()=>{
            this.globalSubclipsConfigFromServer();
            this.globalLDAPConfigFromServer();
            this.getConfiguredTranscoderProfilesFromServer().then(data=>{
                if (Utils.isAcceptedStatusCode(data.statusCode) && data.profiles && data.profiles.length > 0) {
                    this.transcoderProfiles = data.profiles
                }
            })
            this.getGlobalSearchSettingsDetailsFromServer().then(data=>{
                if('search_settings' in data && data.search_settings && data.search_settings.length){
                    this.searchSConfigurations = data.search_settings[0]
                }
            })
        });    
        this.registerWebsocketNotifier();
    },

    mounted(){
        this.getDateTimeFormatDropdownList();
        this.getDateFormatDropdownList();
        this.getApplicationTimeZonesDropdownList();
        this.getActiveLanguagesList();
        this.getSearchInKeywordsList();
        this.observeResize();
    },
    beforeDestroy(){
        this.unRegisterWebsocketNotifier();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $readOnly-bg-color: #1e2326 !important;


    .empty-field-text-styles{
        color:$none-text-color;
    }

    .svg-icon{
        color:$dull-text-color !important;
    }

    .editIcon {
        margin-inline-start: 9px;
    }
    #contact_number_input::-webkit-outer-spin-button,
    #contact_number_input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .comm-table-styles {
        tbody {
            margin: 10px;
            .key-div {
                text-align: end;
                color: $dull-text-color;
                width:30%;
            }
            .value-div {
                text-align: start;
                margin-inline-start: 10px;
                width: 60%;
                font-weight: 500;
            }
        }
    }

    .activeclass {
        color: $active-blue;
    }

    table {
        background: transparent;
    thead {
        th {
            color: $dull-text-color;
            border-top: none !important;
            border-bottom: none !important;
        }
    }
    tbody {
            color: $text-color;
        td {
            border-top: none !important;
        }
    }
    }

    .btn {
        font-size: 14px !important;
        height: 100%;
    }

    .custom-control-label::before {
        background-color: $primary-background;
    }

    table.comm-table-styles .editIcon {
        visibility: hidden;
    }
    table.comm-table-styles td.value-div:hover .editIcon {
        visibility: visible;
    }

    .disablefield {
        border: none !important;
        pointer-events: none;
    }

    .validationmessage {
        color: $danger-color;
        font-size: 11px;
    }

    .nav-item{
        color: $dull-text-color !important;
    }
    .inactive:hover{
        color:$text-color !important;
    }
    .active{
        background: $primary-background !important;
        color:$active-blue  !important;
        border-bottom: 2px solid $active-blue ;
        font-weight: 500;
        font-size:15px;
    }
    .top-nav-bar{
        background: $primary-background;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
        height:5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }

    .comm-input-field-style{
        background: $primary-background!important;
        width: 100% !important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }

    .align-input-field{
        margin-top:-8px !important;
    }

    .config-desc{
        color: $dull-text-color;
        font-size: 14px;
        margin-top: 1px;
    }

    .custom-control-label{
        line-height:25px;
    }

    .config-desc,.custom-control{
        width: 100%;
        text-align: initial;
    }

    .custom-switch .custom-control-label::before{
        background: transparent;
    }
    .custom-control-input:checked~.custom-control-label:before {
        color: #fff;
        border-color: #007bff;
        background-color: #007bff !important;
    }

    input[type='checkbox']:after{
        line-height: 1.5em;
        content: '';
        display: inline-block;
        width: 22px;
        height: 21px;
        margin-top: 5px;
        margin-inline-start: -1px;
        border: $border-color;
        border-radius: 0.25em;
        background: $primary-background;
    }

    input[type='checkbox']:checked:after{
        content: '✔';
        color: $active-blue !important;
        // position: absolute;
        font-size: 16px;
        line-height: 1;
        transition: all .2s;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px;
        padding-top:2px;
    }

    .branding_logo_upload_wrapper,.branding_workspace_logo_wrapper{
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        border: 1px solid #343434;
        padding: 12px;
        border-radius: 7px;
        height: 36px;
    }

    .branding_logo_upload_wrapper:hover,.branding_workspace_logo_wrapper:hover{
       background: #0606064f;
    }

    .search-in-filter-styles{
        padding: 2px 8px;
        margin-inline-end: 5px;
        margin-bottom:5px;
        background-color: #1a1e21 !important;
        border: 1px solid #4a4a4a;
        border-radius: 5px;
        font-size: 14px;
        cursor: default;
    }

    .catalogs-display-styles{
        background-color: #282d31 !important;
        border: 1px solid #363636;
        border-radius: 20px;
        padding: 4px 10px;
    }
    ::v-deep{
        .catalogs-multiselect{
            .selected-tags-style{
                margin-inline-end: 2px;
            }
            .multiselect__tags{
                height: unset !important;
                padding-bottom:4px !important;
            }
            .multiselect{
                height: unset !important;
            }
        }
        .readonlyDiv{
            background: $readOnly-bg-color;
            pointer-events: none;
            border:none !important;
            label{
            width: 45%
            }
            .multiselect__tags{
            border: none !important;
            background: transparent !important;
            }
        }
        .multiselect{
                width:100%;
                margin: 3px 0px;
                // display: flex; this is commented bcz if dispalay : flex given then dropdown will be overlap on the feild
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .tags-style{
            margin:5px;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
            min-height:30px !important;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .align-input-field-assets-search{
            .multiselect__tags{
                height: auto !important;
            }
        }

        .multiselect__tags{
            display: block;
            align-items: center;
            width: 100%;
            height: 44px !important;
            padding: 5px 40px 0 8px!important;
              .selected-tags-style{
                  margin : 0px;
              }
            
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:$dull-text-color !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background;
            color:$dull-text-color;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:38px;
            }
            .multiselect{
                margin:0px !important;
            }
        }
        .multiselect__tags-wrap{
            max-height:130px !important;
            display: inline-block;
            overflow: auto;
        }
        .multiselect__tags-wrap::-webkit-scrollbar {
            width: 8px;
        }

        .multiselect__tags-wrap::-webkit-scrollbar-track {
            background: $scrollbar-track-background;
        }

        .multiselect__tags-wrap::-webkit-scrollbar-thumb {
            background: $scrollbar-thumb-background;
        }

        .multiselect__tags-wrap::-webkit-scrollbar-thumb:hover {
            background: $scrollbar-thumb-on-hover-background;
        }
    }

    .delete-icon{
        position: absolute;
        inset-inline-end: -4px;
        top: -4px;
        height: 23px;
        width: 23px;
        border: $border-color;
        background: $primary-background;
        border-radius: 30px;
        color: $text-color;
      }
      .delete-icon{
        visibility: hidden;
      }
      .hover-to-show-delete-icon:hover{
        box-shadow: 0px 0px 0px 1px rgba(58,58,58,1);
        .delete-icon{
            visibility:visible;
        }
      }
      .hover-to-show-delete-icon{
        position:relative;
        padding:2px;
      }

      .select-filters{
        display: flex;
        position: relative;
        top: 0px;
        background: #1a1d21;
        z-index: 99;
        overflow-x: auto;
        overflow-x: scroll; /* Enable horizontal scrolling */
        overflow-y: hidden;
        scrollbar-width: none;
        .notification-filters{
            border:$border-color;
            border-radius: 20px;
            padding: 13px;
            display: flex;
            align-items: center;
            margin-inline-end: 5px;
            height:30px;
            color: $secondary-text-color;
            width: max-content;
            flex:none;
            margin: 6px 3px;
            // background: $tags-background-color;
        }
      }
      
      .activeFilter{
        color: #007bfc !important;
        border:1px solid #007bfc !important;
      }
      
      .blink {
        tr{
            background: #212529 !important;
        }
       background: #212529 !important;
      }
    
      .disabledArrow{
        fill: #7a7a7a;
        cursor: disabled !important;
        border: 1px solid #7a7a7a !important;
      }

      .select-filters::-webkit-scrollbar {
        display: none; /* Hide scrollbar for Chrome, Safari, and Opera */
      }

      .scroll-icons{
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        top: 9px;
        background: #1a1c21;
        height: 34px;
        width: 8%;
        margin:5px;
      }
    .separator-operator-row {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-right: 25px
    }

    .separator-key {
        font-weight: 500;
        color: #757575;
        margin-right: 8px;
    }

    .custom-select-wrapper {
        position: relative;
        width: 140px;
    }

    .separator-select {
        width: 100%;
        height: 36px;
        padding: 0 35px 0 12px;

        border: 1px solid #4a4a4a !important;
        border-radius: 4px;

        background-color: #1a1e21 !important;
        color: #eee;

        font-size: 14px;
        line-height: 36px;

        cursor: pointer;

        /* Remove browser default arrow */
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;

        outline: none;
    }

    .separator-select:hover {
        border-color: #999;
    }

    .separator-select:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
    }

    .dropdown-arrow {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-55%);

        font-size: 18px;
        color: #6c757d;

        pointer-events: none;
    }
    .more-count {
        font-weight: 500;
        cursor: default;
    }
    .stop-words-container {
        max-height: 450px;
        overflow-y: auto;
        padding: 5px;
    }

    .stop-word-row {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }

    .stop-word-input {
        flex: 1;
    }

    .stop-word-row .v-btn {
        margin-left: 8px;
    }

</style>